import React, { useEffect, useState, useRef } from 'react'
import './styles/index.scss'
import { Card, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
    DownOutlined,
    UpOutlined,
    HomeOutlined,
    PlusOutlined,
    CopyOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
    LinkOutlined,
    DownloadOutlined,
    CheckOutlined,
    CheckCircleOutlined,
    FileAddOutlined,
    PlusCircleOutlined,
    FileSearchOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';
import { Breadcrumb, Dropdown, Button, Select, Typography, Input, Table, Tag, Pagination, ConfigProvider  } from 'antd';
import heIL from 'antd/locale/he_IL';
import { ExcelExportIcon, UploadFileIcon } from '../../../assets/icons/icons';
import { SlidersHorizontal, Link, Settings2, Search } from 'lucide-react';
import { submitCollection } from '../../../_services/submit.service';
import { alertService } from '../../../_services/alert.service';
import { submitSets } from '../../UiComponents/SubmitSets';
import { measureConverter } from '../../../_services/common.service';
import StoreSearchDropdown from './components/storeSearchModal';
import NewClusterModal from './components/newClusterModal';
import DuplicateClusterModal from './components/duplicateClusterModal';
import DeleteClusterModal from './components/deleteClusterModal';
import DeleteWarningModal from './components/deleteWarningModal';
import UnsavedChangesModal from './components/unsavedChangesModal';
import clusterShelfImg from '../../../assets/img/cluster_shelf.png';
import MDSidebarMenu from '../../common_layouts/mdsidebarmenu';
import { data, arrayData } from './clusterData';
import { TooltipWrapper } from '../../newMasterPlanogram/AddMethods';
import StoreAdvancedFilterModal from './components/storeAdvancedFilterModal';
import i18n from '../../../_translations/i18n';
import { ThumbnailSvg } from './components/thumbnailSvg';
import { exportToExcel } from './components/excelExporter';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

// UOM conversion function to convert all units to cm
const convertToCm = (value, uom) => {
    if (!value || !uom) return 0;

    switch (uom.toLowerCase()) {
        case 'cm':
            return value;
        case 'meters':
        case 'meter':
        case 'm':
            return value * 100; 
        case 'inches':
        case 'inch':
        case 'in':
            return value * 2.54; 
        case 'feet':
        case 'foot':
        case 'ft':
            return value * 30.48; 
        default:
            break
    }
};

// Calculate total width in cm from field array using masterField data
const calculateTotalWidthInCm = (fields) => {
    if (!fields || !Array.isArray(fields)) return 0;

    let totalWidthInCm = 0;

    fields.forEach((field, index) => {
        // Use masterField data if available, otherwise fall back to field data
        const masterField = field.masterField;
        const originalWidth = masterField?.width || field.width || 0;
        const originalUom = masterField?.uom || field.uom || 'cm';

        const widthInCm = convertToCm(originalWidth, originalUom);

        totalWidthInCm += widthInCm;
    });
    return totalWidthInCm;
};

export const CustomEmptyData = ({ message = t('NO_DATA_AVAILABLE') }) => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 350px)',
        width: '100%',
        color: '#666666',
        fontSize: '16px',
        fontFamily: 'Mulish, sans-serif',
        fontWeight: '500',
        overflow: 'hidden'
    }}>
        <div style={{ textAlign: 'center' }}>
            {message}
        </div>
    </div>
);

const clusters = (props) => {

    const [searchText, setSearchText] = useState('');
    const [isAdd, setIsAdd] = useState(false)
    const [loading, setLoading] = useState(false)
    const [modalVisible, setModalVisible] = useState(false);
    const [newClusterModalVisible, setNewClusterModalVisible] = useState(false);
    const [activeTab, setActiveTab] = useState('clusters');  
    const [hoveredRowKey, setHoveredRowKey] = useState(null);
    const [hoveredArrayRowKey, setHoveredArrayRowKey] = useState(null);
    const [selectedStoreKeys, setSelectedStoreKeys] = useState({});
    const [allDepartments, setAllDepartments] = useState([]); 
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
    const [clustersData, setClustersData] = useState([]);
    const [clustersLoading, setClustersLoading] = useState(false);
    const [arraysLoading, setArraysLoading] = useState(false);
    const [storeAdvancedFilterModalVisible, setStoreAdvancedFilterModalVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editClusterData, setEditClusterData] = useState(null);
    const [arraysData, setArraysData] = useState([]);
    const [backendArraysData, setBackendArraysData] = useState([]);
    const [allClusters, setAllClusters] = useState([])
    const [activeArrLinkBtn, setActive] = useState("cluster");
    const [selectedClusterForModal, setSelectedClusterForModal] = useState(null);
    const [selectedArrayForModal, setSelectedArrayForModal] = useState(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [selectedClusterForSave, setSelectedClusterForSave] = useState(null);
    const [selectedArrayForSave, setSelectedArrayForSave] = useState(null);
    const [clusterArrayChanges, setClusterArrayChanges] = useState({});
    const [arrayClusterChanges, setArrayClusterChanges] = useState({});
    const [storeArrayChanges, setStoreArrayChanges] = useState({});
    const [selectedClusterForArrayTab, setSelectedClusterForArrayTab] = useState(null);
    const [selectedArrayForArrayTab, setSelectedArrayForArrayTab] = useState(null);
    const [isLinkingInArrayTab, setIsLinkingInArrayTab] = useState(false);
    const [duplicateModalVisible, setDuplicateModalVisible] = useState(false);
    const [clusterToDuplicate, setClusterToDuplicate] = useState(null);
    const [isDuplicating, setIsDuplicating] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [clusterToDelete, setClusterToDelete] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [warningModalVisible, setWarningModalVisible] = useState(false);
    const [warningClusterData, setWarningClusterData] = useState(null);
    const [unsavedChangesModalVisible, setUnsavedChangesModalVisible] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const departmentSelectRef = useRef(null);
    const [allDepartmentStores, setAllDepartmentStores] = useState([]);
    const [preventAutoOpen, setPreventAutoOpen] = useState(false);
    const [selecedPlusInArray, setSelectedPlusInArray] = useState(false)
    const [globalToast, setGlobalToast] = useState(null);

    const [arrayPageSize] = useState(20);
    const [arrayCurrentPage, setArrayCurrentPage] = useState(1);
    const [isLoadingMoreArrays, setIsLoadingMoreArrays] = useState(false);
    const arrayTableRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
const [totalCount, setTotalCount] = useState(0);
const pageSize = 100;

    const { t } = useTranslation()

    const showGlobalToast = (type, message, duration = 3000) => {
        setGlobalToast({ type, message });
        setTimeout(() => setGlobalToast(null), duration);
    };

    const storeColumns = [
        {
            dataIndex: 'storeCode',
            key: 'storeId',
            width: '15%',
            render: (text) => (
                <div style={{ paddingLeft: '20px', fontSize: '12px', color: props.dmode ? '#ccc' : '#666' }}>
                    {text}
                </div>
            ),
        },
        {
            dataIndex: 'storeName',
            key: 'storeName',
            width: '17%',
            align: 'left',
            render: (text) => (
                <span style={{ fontSize: '13px', fontWeight: 600 }}>{text}</span>
            ),
        },
        {
            dataIndex: 'storeRegion',
            key: 'regionName',
            width: '14%',
            align: 'left',
            render: (storeRegion) => (
                <span style={{ fontSize: '13px' }}>{storeRegion?.regionName || ''}</span>
            ),
        },
        {
            dataIndex: 'tagNames',
            key: 'tagNames',
            width: '16%',
            align: 'center',
            render: (tagNames, record) => (
                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                    {tagNames && tagNames.length > 0 && tagNames.map((tag, index) => (
                        <Tag 
                            key={index}
                            color="purple" 
                            style={{ 
                                fontSize: '12px', 
                                border: 'none', 
                                color: '#4F4F4F', 
                                fontWeight: 600,
                                backgroundColor: '#F2F1FF'
                            }}
                        >
                            {tag}
                        </Tag>
                    ))}
                </div>
            ),
        },
        // {
        //     dataIndex: 'holiday2',
        //     key: 'holiday2',
        //     width: '8%',
        //     align: 'center',
        //     render: (text, record) => (
        //         <Tag 
        //             color="purple" 
        //             style={{ 
        //                 fontSize: '12px', 
        //                 marginRight: 2, 
        //                 border: 'none', 
        //                 color: '#4F4F4F', 
        //                 fontWeight: 600,
        //                 backgroundColor: undefined
        //             }}
        //         >
        //             {text}
        //         </Tag>
        //     ),
        // },
      {
            dataIndex: 'linkArrayName',
            key: 'linkArrayName',
            width: '28%',
            render: (text, record) => {
                // Show 'None' for unassigned stores, centered
                if (record.key && (record.key.includes('unassigned-cluster-') || record.key.includes('unassigned-array-'))) {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                            <span style={{ fontSize: '12px', color: '#666' }}>{t('NONE')}</span>
                        </div>
                    );
                }
                
                // Normal content for assigned stores
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: activeTab === 'arrays' ? '30px' : '0px' }}>
                         <ConfigProvider
                            locale={heIL}
                            direction={props.isRTL === "rtl" ? "rtl" : "ltr"}
                        >
                        {activeTab === 'clusters' ? (
                            <Select
                                value={storeArrayChanges[record.key] !== undefined ? 
                                    storeArrayChanges[record.key] : 
                                    (record.fieldArray?.fieldArrayId || undefined)
                                }
                                placeholder={t('LINKED_ARRAY_NAME')}
                                style={{ 
                                    width: 190, 
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    direction: 'ltr'
                                }}
                                popupClassName={props.isRTL === 'rtl' ? 'rtl-dropdown' : ''}
                                size="small"
                                showSearch
                                optionFilterProp="labelText"
                                filterOption={(input, option) => {
                                    const searchText = option.labelText || '';
                                    return searchText.toLowerCase().includes(input.toLowerCase());
                                }}
                                className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                onChange={(value) => {
                                    setStoreArrayChanges(prev => ({
                                        ...prev,
                                        [record.key]: value === 'None' ? null : value
                                    }));
                                }}
                                options={[
                                    { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                    ...arraysData.map(option => {
                                        // Find the parent cluster for this store to get the main table's selected array
                                        const parentCluster = clustersData.find(cluster => 
                                            cluster.stores?.some(store => store.key === record.key)
                                        );
                                        
                                        // Get the main table's selected array (either from pending changes or current value)
                                        const mainTableArrayId = parentCluster ? 
                                            (clusterArrayChanges[parentCluster.clusterId] !== undefined ? 
                                                clusterArrayChanges[parentCluster.clusterId] : 
                                                parentCluster.fieldArray?.fieldArrayId
                                            ) : null;
                                        
                                        // Only validate if there's a selected array in the main table
                                        const hasSelectedArray = mainTableArrayId && mainTableArrayId !== 'None' && mainTableArrayId !== null;
                                        const validation = hasSelectedArray ? validateArrayCompatibility(option, mainTableArrayId) : { isCompatible: true, reason: null };
                                        const showWarning = hasSelectedArray && !validation.isCompatible;
                                        
                                        return {
                                            value: option.value,
                                            labelText: option.label,
                                            label: (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span style={{ 
                                                        maxWidth: showWarning ? '80%' : 'none',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {option.label}
                                                    </span>
                                                    {showWarning && (
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                <Tooltip className="custom-warning-tooltip">
                                                                    <div style={{
                                                                        textAlign: 'left',
                                                                        maxWidth: '300px',
                                                                        backgroundColor: '#5128a0',
                                                                        color: '#fff',
                                                                        padding: '8px 12px',
                                                                        borderRadius: '4px'
                                                                    }}>
                                                                        {validation.reason.split('\n').map((reason, index) => (
                                                                            <div key={index} style={{
                                                                                display: 'flex',
                                                                                alignItems: 'flex-start',
                                                                                marginBottom: index < validation.reason.split('\n').length - 1 ? '4px' : '0'
                                                                            }}>
                                                                                <span style={{ marginRight: '8px', flexShrink: 0 }}>•</span>
                                                                                <span style={{ flex: 1 }}>{reason}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <ExclamationCircleOutlined
                                                                style={{
                                                                    color: '#faad14',
                                                                    fontSize: '12px',
                                                                    marginLeft: '8px'
                                                                }}
                                                            />
                                                        </OverlayTrigger>
                                                    )}
                                                </div>
                                            )
                                        };
                                    })
                                ]}
                            />
                        ) : (
                            <Select
                                placeholder={t('LINKED_CLUSTER_NAME')}
                                value={arrayClusterChanges[record.key] !== undefined ? 
                                    arrayClusterChanges[record.key] : 
                                    (record.cluster?.clusterId || undefined)
                                }
                                onChange={(value) => {
                                    setArrayClusterChanges(prev => ({
                                        ...prev,
                                        [record.key]: value === 'None' ? null : value
                                    }));
                                }}
                                style={{ 
                                    width: 190, 
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    direction: 'ltr'
                                }}
                                popupClassName={props.isRTL === 'rtl' ? 'rtl-dropdown' : ''}
                                size="small"
                                showSearch
                                optionFilterProp="labelText"
                                filterOption={(input, option) => {
                                    const searchText = option.labelText || '';
                                    return searchText.toLowerCase().includes(input.toLowerCase());
                                }}
                                className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                 options={[
                                    { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                    ...allClusters.map(cluster => ({
                                        ...cluster,
                                        labelText: cluster.label || cluster.name || ''
                                    }))
                                ]}
                            />
                        )}
                        </ConfigProvider>
                        {activeTab === 'clusters' && <ThumbnailSvg fields={record.fieldArray?.fields || []} dmode={props.dmode} />}
                    </div>
                );
            },
        },
        {
            dataIndex: 'width',
            key: 'width',
            width: '2%',
            // align: 'right',
            render: (text, record) => {
                if (activeTab !== 'clusters') return null;
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            // marginRight: -4, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        W {text || '0'}
                    </Tag>
            )}
        },
        {
            dataIndex: 'fields',
            key: 'fields',
            width: '2%',
            // align: 'left',
            render: (text, record) => {
                if (activeTab !== 'clusters') return null;
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            // marginLeft: -4,
                            // marginRight: 2, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        F {text || '0'}
                    </Tag>
            )},
        }
    ];

    const columns = [
            {
            dataIndex: 'clusterName',
            key: 'clusterName',
            width: '35%',
            render: (text, record) => (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        justifyContent: 'flex-start',
                        flexDirection:  'row',
                        position: 'relative'
                    }}
                    onMouseEnter={() => setHoveredRowKey(record.key)}
                    onMouseLeave={() => setHoveredRowKey(null)}
                >
                    <div>
                        <div style={{ fontWeight: 600, marginBottom: 2, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-purple">
                                        {text || ''}
                                    </Tooltip>
                                }
                            >
                                <div style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '200px'
                                }}>
                                    {text}
                                </div>
                            </OverlayTrigger>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <Link size={14} />
                                <span style={{ fontSize: '12px', color: props.dmode ? '#ccc' : '#666', fontWeight: 600 }}>
                                    {record.stores ? record.stores.length : 0}
                                </span>
                            </div>
                        </div>
                        {record.key !== 'unassigned-clusters' && <div style={{ fontSize: '12px', color: props.dmode ? '#ccc': '#666' }}>{`${t('CODE')}: #${record.code || record.clusterCode}`}</div>}
                    </div>
                    {hoveredRowKey === record.key && record.key !== 'unassigned-clusters' && (
                        <div className="hover-buttons-container" style={{ display: 'flex',  gap: '4px' }}>
                            <Button
                            size='small' 
                                icon={<PlusOutlined style={{ color: '#4F4F4F' }} />} 
                                style={{
                                    backgroundColor: '#F2F1FF',
                                    border: '1px solid #828282',
                                    borderRadius: '5px',
                                    color: '#4F4F4F',
                                    height: '24px',
                                    width: '24px',
                                    minWidth: '24px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                onClick={() => {
                                    if (hasUnsavedChanges()) {
                                        setPendingAction(() => () => {
                                            setStoreAdvancedFilterModalVisible(true);
                                            setSelectedClusterForModal(record);
                                            setSelectedArrayForModal(null);
                                        });
                                        setUnsavedChangesModalVisible(true);
                                    } else {
                                        setStoreAdvancedFilterModalVisible(true);
                                        setSelectedClusterForModal(record);
                                        setSelectedArrayForModal(null);
                                    }
                                }
                            }
                            />
                            <Button 
                                size='small' 
                                icon={<CopyOutlined style={{ color: '#4F4F4F' }} />} 
                                style={{
                                    backgroundColor: '#F2F1FF',
                                    border: '1px solid #828282',
                                    borderRadius: '5px',
                                    color: '#4F4F4F',
                                    height: '24px',
                                    width: '24px',
                                    minWidth: '24px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                onClick={() => {
                                    // Open duplicate modal immediately
                                    setClusterToDuplicate(record);
                                    setDuplicateModalVisible(true);
                                    // Check for unsaved changes after modal is open to show unsaved changes modal on top
                                    setTimeout(() => {
                                        if (hasUnsavedChanges()) {
                                            setUnsavedChangesModalVisible(true);
                                        }
                                    }, 100);
                                }}
                            />
                            <Button 
                                size='small'
                                icon={<EditOutlined style={{ color: '#4F4F4F' }} />} 
                                style={{
                                    backgroundColor: '#F2F1FF',
                                    border: '1px solid #828282',
                                    borderRadius: '5px',
                                    color: '#4F4F4F',
                                    height: '24px',
                                    width: '24px',
                                    minWidth: '24px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                onClick={() => {
                                    // Open edit modal immediately
                                    setEditClusterData(record);
                                    setIsEditMode(true);
                                    setNewClusterModalVisible(true);
                                    // Check for unsaved changes after modal is open to show unsaved changes modal on top
                                    setTimeout(() => {
                                        if (hasUnsavedChanges()) {
                                            setUnsavedChangesModalVisible(true);
                                        }
                                    }, 100);
                                }}
                            />
                            <Button 
                                size='small'
                                icon={<DeleteOutlined style={{ color: '#4F4F4F' }} />} 
                                style={{
                                    backgroundColor: '#F2F1FF',
                                    border: '1px solid #828282',
                                    borderRadius: '5px',
                                    color: '#4F4F4F',
                                    height: '24px',
                                    width: '24px',
                                    minWidth: '24px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                onClick={() => {
                                        // Open delete modal immediately
                                        setClusterToDelete(record);
                                        setDeleteModalVisible(true);
                                        // Check for unsaved changes after modal is open to show unsaved changes modal on top
                                        setTimeout(() => {
                                            if (hasUnsavedChanges()) {
                                                setUnsavedChangesModalVisible(true);
                                            }
                                        }, 100);
                                }}
                            />
                        </div>
                    )}
                </div>
            ),
        },
        {
            dataIndex: 'linkArrayName',
            key: 'linkArrayName',
            width: '35%',
            render: (text, record) => {
                // Hide this column content for unassigned rows
                if (record.key === 'unassigned-clusters') {
                    return <div style={{ width: '100%' }}></div>;
                }
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '30px' }}>
                        <ConfigProvider
                            locale={heIL}
                            direction={props.isRTL === "rtl" ? "rtl" : "ltr"}
                        >
                        <Select
                            placeholder={t('LINKED_ARRAY_NAME')}
                            value={clusterArrayChanges[record.clusterId] !== undefined ? 
                                clusterArrayChanges[record.clusterId] : 
                                (text ? text : undefined)
                            }
                            onChange={ (value) => {
                                if (value && value !== 'None') {                                 
                                    const selectedArray = backendArraysData.find(arr => arr.key == value);                               
                                    if (selectedArray && selectedArray.fields === '0') {
                                        alertService.error(t('UNITS_ARE_NOT_ASSIGNED'));
                                    }
                                }

                                // Check if there are existing unsaved changes from other clusters
                                const currentClusterHasChanges = clusterArrayChanges[record.clusterId] !== undefined;
                                const otherClustersHaveChanges = Object.keys(clusterArrayChanges).some(
                                    clusterId => clusterId !== record.clusterId.toString()
                                );
                                const hasOtherUnsavedChanges = Object.values(selectedStoreKeys).some(keys => keys.length > 0) ||
                                    Object.keys(arrayClusterChanges).length > 0 ||
                                    Object.keys(storeArrayChanges).length > 0;

                                if ((otherClustersHaveChanges || hasOtherUnsavedChanges) && !currentClusterHasChanges) {
                                    // Store the pending change and show unsaved changes modal
                                    setPendingAction(() => () => {
                                        setClusterArrayChanges(prev => ({
                                            ...prev,
                                            [record.clusterId]: value === 'None' ? null : value
                                        }));
                                    });
                                    setUnsavedChangesModalVisible(true);
                                } else {
                                    // No conflicts, proceed with the change
                                    setClusterArrayChanges(prev => ({
                                        ...prev,
                                        [record.clusterId]: value === 'None' ? null : value
                                    }));
                                }
                            }}
                            style={{ 
                                width: 190, 
                                fontSize: '12px',
                                textAlign: props.isRTL === 'rtl' ? 'left' : 'left'
                            }}
                            popupClassName={props.isRTL === 'rtl' ? 'rtl-dropdown' : ''}
                            size="small"
                            showSearch
                            optionFilterProp="labelText"
                            filterOption={(input, option) => {
                                const searchText = option.labelText || '';
                                return searchText.toLowerCase().includes(input.toLowerCase());
                            }}
                            className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                            options={[
                                { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                ...arraysData
                                    .map(option => {
                                        // Validate against minimum store array width
                                        const backendData = backendArraysData.find(arr => arr.key == option.value);
                                        const validation = backendData ? validateMainTableArrayWidth(option, record) : { isCompatible: true };
                                        const showWarning = backendData && !validation.isCompatible;
                                        
                                        return {
                                            value: option.value,
                                            labelText: option.label, 
                                            label: (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span style={{ 
                                                        maxWidth: showWarning ? '80%' : 'none',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {option.label}
                                                    </span>
                                                    {showWarning && (
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                <Tooltip className="custom-warning-tooltip">
                                                                    <div style={{
                                                                        textAlign: 'left',
                                                                        maxWidth: '300px',
                                                                        backgroundColor: '#5128a0',
                                                                        color: '#fff',
                                                                        padding: '8px 12px',
                                                                        borderRadius: '4px'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'flex-start'
                                                                        }}>
                                                                            <span style={{ marginRight: '8px', flexShrink: 0 }}>•</span>
                                                                            <span style={{ flex: 1 }}>{validation.reason}</span>
                                                                        </div>
                                                                    </div>
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <ExclamationCircleOutlined
                                                                style={{
                                                                    color: '#faad14',
                                                                    fontSize: '12px',
                                                                    marginLeft: '8px'
                                                                }}
                                                            />
                                                        </OverlayTrigger>
                                                    )}
                                                </div>
                                            )
                                        };
                                    })
                            ]}
                        />
                        </ConfigProvider>
                        <ThumbnailSvg fields={record.fieldsArrayHasFields || []} dmode={props.dmode} />
                    </div>
                );
            },
        },
        {
            dataIndex: 'width',
            key: 'width',
            width: '1%',
            align: 'right',
            render: (text, record) => {
                // Hide this column content for unassigned rows
                if (record.key === 'unassigned-clusters') {
                    return null;
                }
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            marginRight: -8, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        {t('FIELD_ARRAY_LETTERS.W')} {text || '0'}
                    </Tag>
                );
            },
        },
        {
            dataIndex: 'fields',
            key: 'fields',
            width: '1%',
            align: 'left',
            render: (text, record) => {
                // Hide this column content for unassigned rows
                if (record.key === 'unassigned-clusters') {
                    return null;
                }
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            // marginLeft: -8,
                            marginRight: 2, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        {t('FIELD_ARRAY_LETTERS.F')} {text || '0'}
                    </Tag>
                );
            },
        },
        {
            dataIndex: 'description',
            key: 'description',
            width: '15%',
            render: (text) => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-purple">
                            {text || ''}
                        </Tooltip>
                    }
                >
                    <div style={{ 
                        color: props.dmode ? '#ccc' : '#666', 
                        fontSize: '13px',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: '1.4',
                        maxWidth: '100%',
                        wordBreak: 'break-word'
                    }}>{text || ''}</div>
                </OverlayTrigger>
            ),
        },
    ];

     // Array columns for "By Arrays" tab
    const arrayColumns = [
        {
            dataIndex: 'arrayName',
            key: 'arrayName',
            width: '80%',
            render: (text, record) => (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        justifyContent: 'flex-start',
                        flexDirection: 'row'
                    }}
                    onMouseEnter={() => setHoveredArrayRowKey(record.key)}
                    onMouseLeave={() => setHoveredArrayRowKey(null)}
                >
                    <div>
                        <div style={{ fontWeight: 600, marginBottom: 2, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-purple">
                                        {text || ''}
                                    </Tooltip>
                                }
                            >
                                <span style={{ 
                                    maxWidth: '200px', 
                                    overflow: 'hidden', 
                                    textOverflow: 'ellipsis', 
                                    whiteSpace: 'nowrap',
                                    display: 'inline-block'
                                }}>
                                    {text}
                                </span>
                            </OverlayTrigger>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <Link size={14} />
                                <span style={{ fontSize: '12px', color: props.dmode ? '#ccc' : '#666', fontWeight: 600 }}>
                                    {record.stores ? record.stores.length : 0}
                                </span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center'}}>
                            {record.key !== 'unassigned-arrays' && (
                                <ThumbnailSvg
                                    fields= {record.fieldsArrayHasFields}
                                    dmode={props.dmode}
                                />
                            )}
                            </div>
                        </div>
                        <div style={{ fontSize: '12px', color: props.dmode ? '#ccc' : '#666' }}>{record.code}</div>
                    </div>
                    {hoveredArrayRowKey === record.key && record.key !== 'unassigned-arrays' && (
                        <div className="hover-buttons-container array" style={{ display: 'flex', alignItems: 'flex-start', gap: '4px' }}>
                            <Button 
                                size='small'
                                icon={<PlusOutlined style={{ color: '#4F4F4F' }} />} 
                                style={{
                                    backgroundColor: '#F2F1FF',
                                    border: '1px solid #828282',
                                    borderRadius: '5px',
                                    color: '#4F4F4F',
                                    height: '24px',
                                    width: '24px',
                                    minWidth: '24px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                                onMouseLeave={(e) => e.target.style.opacity = '1'}
                                onClick={() => {
                                    if (hasUnsavedChanges()) {
                                        setPendingAction(() => () => {
                                            setStoreAdvancedFilterModalVisible(true);
                                            setSelectedArrayForModal(record);
                                            setSelectedPlusInArray(true);
                                            setSelectedClusterForModal(null);
                                        });
                                        setUnsavedChangesModalVisible(true);
                                    } else {
                                        setStoreAdvancedFilterModalVisible(true);
                                        setSelectedArrayForModal(record);
                                        setSelectedPlusInArray(true);
                                        setSelectedClusterForModal(null);
                                    }
                                }
                            }
                            />
                        </div>
                    )}
                </div>
            ),
        },
        // {
        //     dataIndex: 'linkArrayName',
        //     key: 'linkArrayName',
        //     width: '20%',
        //     render: (text, record) => {
        //         // Hide this column content for unassigned rows
        //         if (record.key === 'unassigned-arrays') {
        //             return null;
        //         }
        //         return (
        //             <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '30px' }}>
        //                 <Select
        //                     placeholder="Linked Cluster Name"
        //                     value={arrayClusterChanges[record.key] !== undefined ? 
        //                         arrayClusterChanges[record.key] : 
        //                         (text ? text : undefined)
        //                     }
        //                     onChange={(value) => {
        //                         setArrayClusterChanges(prev => ({
        //                             ...prev,
        //                             [record.key]: value === 'None' ? null : value
        //                         }));
        //                     }}
        //                     style={{ width: 190, fontSize: '12px' }}
        //                     size="small"
        //                      options={[
        //                             { value: 'None', label: t('LINKED_CLUSTER_NAME') },
        //                             ...allClusters
        //                         ]}
        //                 />
        //                 {/* <img 
        //                     src={clusterShelfImg} 
        //                     alt="Cluster Shelf" 
        //                     style={{ 
        //                         width: '86px', 
        //                         height: '20px',
        //                         flexShrink: 0
        //                     }} 
        //                 /> */}
        //             </div>
        //         );
        //     },
        // },
        {
            dataIndex: 'width',
            key: 'width',
            width: '1%',
            align: 'right',
            render: (text, record) => {
                // Hide this column content for unassigned rows
                if (record.key === 'unassigned-arrays') {
                    return null;
                }
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            marginRight: -8, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        {t('FIELD_ARRAY_LETTERS.W')} {text || '0'}
                    </Tag>
                );
            },
        },
        {
            dataIndex: 'fields',
            key: 'fields',
            width: '1%',
            align: 'center',
            render: (text, record) => {
                // Hide this column content for unassigned rows
                if (record.key === 'unassigned-arrays') {
                    return null;
                }
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            marginLeft: -8,
                            marginRight: -8, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        {t('FIELD_ARRAY_LETTERS.F')} {text || '0'}
                    </Tag>
                );
            },
        },
        {
            dataIndex: 's6',
            key: 's6',
            width: '1%',
            align: 'left',
            render: (text, record) => {
                // Hide this column content for unassigned rows
                if (record.key === 'unassigned-arrays') {
                    return null;
                }
                return (
                    <Tag 
                        color="purple" 
                        style={{ 
                            fontSize: '12px', 
                            marginLeft: -8,
                            marginRight: 2, 
                            border: 'none', 
                            color: '#4F4F4F', 
                            fontWeight: 600,
                            backgroundColor: undefined
                        }}
                    >
                        {t('FIELD_ARRAY_LETTERS.S')} {text || '0'}
                    </Tag>
                );
            },
        },
        {
            dataIndex: 'description',
            key: 'description',
            width: '15%',
            render: (text) => (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-purple">
                            {text || ''}
                        </Tooltip>
                    }
                >
                    <Text style={{ 
                        color: props.dmode ? '#ccc' : '#666', 
                        fontSize: '13px',
                        maxWidth: '162px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'inline-block'
                    }}>
                        {text || ''}
                    </Text>
                </OverlayTrigger>
            ),
        },
    ];

    const handleSearch = (value) => {
        setSearchText(value);
    };

    useEffect(() => {
        // Fetch all departments when the component mounts
        getAllDepartments();
        getAllArrays();
        getClusterList()
    }, []);

    // Auto-focus department select when departments are loaded
    // useEffect(() => {
    //     if (allDepartments.length > 0 && departmentSelectRef.current && !selectedDepartmentId) {
    //         setTimeout(() => {
    //             const selectElement = departmentSelectRef.current;
    //             if (selectElement) {
    //                 // Try to find the input element within the Select component
    //                 const inputElement = selectElement.querySelector('input');
    //                 if (inputElement) {
    //                     inputElement.focus();
    //                 }
    //             }
    //         }, 200);
    //     }
    // }, [allDepartments]);

    // Fetch clusters when department is selected
    useEffect(() => {
        if (selectedDepartmentId) {
            getAllClustersById();
            setCurrentPage(1);
            fetchBackendArraysData(1);
            fetchAllDepartmentStores();
        }
    }, [selectedDepartmentId]);

    // Fetch backend arrays data when switching to arrays tab and department is selected
    useEffect(() => {
        if (activeTab === 'arrays' && selectedDepartmentId && backendArraysData.length === 0) {
            fetchBackendArraysData();
        }
    }, [activeTab]);

    useEffect(() => {
        setArrayCurrentPage(1);
    }, [activeTab, searchText, backendArraysData]);

    const getAllDepartments = () => {
        setLoading(true);
        submitSets(submitCollection.searchDepatments, true).then(res => {
            if (res?.status) {
                // Handle successful response
                const departmentOptions = res.extra.map(department => ({
                    value: department.departmentId,
                    label: department.name
                }));
                setAllDepartments(departmentOptions);
                setLoading(false);
            } else {
                alertService.error(res?.extra || t('FAILED_TO_FETCH_DEPARTMENTS'));
                setLoading(false);
            }
        })
    }

    // Function to check if there are unsaved changes
    const hasUnsavedChanges = () => {
        const hasSelectedStores = Object.values(selectedStoreKeys).some(keys => keys.length > 0);
        const hasClusterArrayChanges = Object.keys(clusterArrayChanges).length > 0;
        const hasArrayClusterChanges = Object.keys(arrayClusterChanges).length > 0;
        const hasStoreArrayChanges = Object.keys(storeArrayChanges).length > 0;

        return hasSelectedStores || hasClusterArrayChanges || hasArrayClusterChanges || hasStoreArrayChanges;
    };

    // Function to check if trying to assign stores to the same cluster they belong to
    const isAssigningToSameCluster = () => {
        if (activeTab !== 'clusters' || !selectedClusterForSave) {
            return false;
        }
        // console.log('ee',storeArrayChanges);

        // Check if any selected stores are from the same cluster as the one selected for save
        return Object.keys(selectedStoreKeys).some(clusterKey => {
            const hasStoresSelected = selectedStoreKeys[clusterKey]?.length > 0;
            
            const isSameCluster = clusterKey == selectedClusterForSave;
            return hasStoresSelected && isSameCluster;
        });
    };

    // Function to check if trying to assign stores to the same array they belong to
    const isAssigningToSameArray = () => {
        if (activeTab !== 'arrays' || !selectedArrayForSave) {
            return false;
        }

        // Check if any selected stores are from the same array as the one selected for save
        return Object.keys(selectedStoreKeys).some(arrayKey => {
            const hasStoresSelected = selectedStoreKeys[arrayKey]?.length > 0;
            const isSameArray = arrayKey == selectedArrayForSave;
            return hasStoresSelected && isSameArray;
        });
    };

    const isAssigningStoreToSameArrayViaDropdown = () => {
        if (activeTab !== 'clusters' || !selectedArrayForSave) {
            return false;
        }

        return Object.keys(selectedStoreKeys).some(clusterKey => {
            const selectedKeys = selectedStoreKeys[clusterKey] || [];
            if (selectedKeys.length === 0) return false;

            const cluster = clustersData.find(c => c.key == clusterKey || c.clusterId == clusterKey);
            if (!cluster || !cluster.stores) return false;

            return selectedKeys.some(storeKey => {
                const store = cluster.stores.find(s => s.key === storeKey);
                if (!store) return false;

                const storeArrayId = store.fieldArray?.fieldArrayId;
                return storeArrayId && storeArrayId == selectedArrayForSave;
            });
        });
    };

    const isAssigningStoreToSameClusterViaDropdown = () => {
        if (activeTab !== 'arrays' || !selectedClusterForSave) {
            return false;
        }

        return Object.keys(selectedStoreKeys).some(arrayKey => {
            const selectedKeys = selectedStoreKeys[arrayKey] || [];
            if (selectedKeys.length === 0) return false;

            const array = backendArraysData.find(arr => arr.key == arrayKey);
            if (!array || !array.stores) return false;

            return selectedKeys.some(storeKey => {
                const store = array.stores.find(s => s.key === storeKey);
                if (!store) return false;

                const storeClusterId = store.cluster?.clusterId;
                return storeClusterId && storeClusterId == selectedClusterForSave;
            });
        });
    };

    // Function to check if data contains only unassigned records
    const hasOnlyUnassignedRecords = () => {
        const dataSource = getCurrentDataSource();
        if (!dataSource || dataSource.length === 0) {
            return true;
        }

        // Check if all records are unassigned
        if (activeTab === 'clusters') {
            return dataSource.length === 1 && dataSource[0].key === 'unassigned-clusters';
        } else {
            return dataSource.length === 1 && dataSource[0].key === 'unassigned-arrays';
        }
    };

    // Function to handle save from unsaved changes modal
    const handleSaveFromModal = async () => {
        try {
            await handleSave();
            setUnsavedChangesModalVisible(false);
            if (pendingAction) {
                pendingAction();
                setPendingAction(null);
            }
        } catch (error) {
        }
    };

    // Function to handle cancel from unsaved changes modal
    const handleCancelFromModal = () => {
        // Clear all unsaved changes but don't execute the pending action
        setSelectedStoreKeys({});
        setClusterArrayChanges({});
        setArrayClusterChanges({});
        setStoreArrayChanges({});
        
        setUnsavedChangesModalVisible(false);
        setPendingAction(null);
    };

    // Function to handle discard from unsaved changes modal
    const handleDiscardFromModal = () => {
        // Clear all unsaved changes and execute the pending action
        setSelectedStoreKeys({});
        setClusterArrayChanges({});
        setArrayClusterChanges({});
        setStoreArrayChanges({});
        
        setUnsavedChangesModalVisible(false);
        if (pendingAction) {
            pendingAction();
            setPendingAction(null);
        }
    };

    // New function to fetch clusters
    const getAllClustersById = async () => {
        if (!selectedDepartmentId) return;

        setClustersLoading(true);
        try {
            const response = await submitSets(
                submitCollection.getAllClusters, 
                { departmentId: selectedDepartmentId }
            );

            if (response?.status) {
              const transformedClusters = response.extra.map(cluster => ({
                key: cluster.clusterId,
                clusterId: cluster.clusterId,
                clusterName: cluster.clusterName,
                code: cluster.clusterCode,
                linkArrayName: cluster.fieldArray?.fieldArrayName,
                width: cluster.fieldArray?.fields
                    ? calculateTotalWidthInCm(cluster.fieldArray.fields).toString()
                    : '0',
                fields: cluster.fieldArray?.fields
                    ? cluster.fieldArray.fields.length.toString()
                    : '0',
                fieldArray: cluster.fieldArray || {},
                fieldsArrayHasFields: cluster.fieldArray?.fields || [],
                description: cluster.clusterDescription || cluster.description || '',
                stores: (cluster.stores || []).map((store, storeIndex) => ({
                    ...store,
                    key: store.key || `${cluster.clusterId}-store-${storeIndex}-${store.storeId || storeIndex}`,
                    storeCode: store.storeCode,
                    storeName: store.storeName,
                    storeRegion: store.storeRegion,
                    tagNames: store.tagNames || [],
                    fieldArray: store.fieldArray || {},
                    width: store.fieldArray?.fields
                        ? calculateTotalWidthInCm(store.fieldArray.fields).toString()
                        : '0',
                    fields: store.fieldArray?.fields
                        ? store.fieldArray.fields.length.toString()
                        : '0'
                }))
            }));
                setClustersData(transformedClusters);
                setAllClusters(
                    transformedClusters.map(cluster => ({
                        value: cluster.clusterId,
                        label: cluster.clusterName
                    })))
            } else {
                setClustersData([]); 
            }
        } catch (error) {
            setClustersData([]);
        } finally {
            setClustersLoading(false);
        }
    };

    const getClusterList = async() => {
        try {
            const response = await submitSets(
                submitCollection.findAllClusters
            );

              if (response?.status) {
              const transformedClusters = response.extra.map(cluster => ({
                value: cluster.clusterId,
                label: cluster.clusterName
            }));
                setAllClusters(transformedClusters);
            } else {
                alertService.error(response?.extra || t('FAILED_TO_FETCH_CLUSTERS'));
                setAllClusters([]); 
            }
        } catch (error) {
            console.error('Error fetching clusters:', error);
            alertService.error(t('FAILED_TO_FETCH_CLUSTERS'));
            setAllClusters([]);
        }finally {
            setClustersLoading(false);
        }
    }

    const handleCreateCluster = async (clusterData) => {
        setLoading(true);
        if(!selectedDepartmentId) {
            return alertService.error(t('PLEASE_SELECT_DEPARTMENT'))
        }
        try {
            const response = await submitSets(
                submitCollection.createCluster,
                { ...clusterData, departmentId: selectedDepartmentId }
            );

            if (!response?.status) {
                alertService.error(response?.extra);
                return;
            }

            alertService.success(t('CLUSTER_CREATED_SUCCESSFULLY'));
            setNewClusterModalVisible(false);
            
             await getAllClustersById();
            
        } catch (error) {
            alertService.error(error.message || t('FAILED_TO_CREATE_CLUSTER'));
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateCluster = async (clusterData) => {
        setLoading(true);
        try {
            const response = await submitSets(
                submitCollection.updateCluster,
                { ...clusterData, departmentId: selectedDepartmentId, clusterId: editClusterData?.clusterId }
            );

            if (!response?.status) {
                alertService.error(response?.extra);
                return;
            }

            alertService.success(t('CLUSTER_UPDATED_SUCCESSFULLY'));
            setNewClusterModalVisible(false);
            setIsEditMode(false);
            setEditClusterData(null);
            
            await getAllClustersById();
            
        } catch (error) {
            alertService.error(error.message || t('FAILED_TO_UPDATE_CLUSTER'));
        } finally {
            setLoading(false);
        }
    };

    const handleDuplicateCluster = async () => {
        if (!clusterToDuplicate) return;

        setIsDuplicating(true);        
        try {
            const payload = {
                clusterId: clusterToDuplicate.clusterId,
                departmentId: selectedDepartmentId,
                fieldArrayId: clusterToDuplicate.fieldArray?.fieldArrayId || null
            };

            const response = await submitSets(
                submitCollection.duplicateCluster,
                payload
            );

            if (!response?.status) {
                alertService.error(response?.extra || t('FAILED_TO_DUPLICATE_CLUSTER'));
                return;
            } else {
            // const tempId = Date.now();
            
            // const duplicatedCluster = {
            //     key: tempId,
            //     clusterId: tempId, 
            //     clusterName: `${clusterToDuplicate.clusterName} v1`,
            //     code: `${clusterToDuplicate.code}-copy`,
            //     linkArrayName: clusterToDuplicate.linkArrayName,
            //     width: clusterToDuplicate.width || '0',
            //     fields: clusterToDuplicate.fields || '0',
            //     fieldArray: clusterToDuplicate.fieldArray || {},
            //     fieldsArrayHasFields: clusterToDuplicate.fieldsArrayHasFields || [],
            //     description: clusterToDuplicate.description || '',
            //     stores: [] 
            // };

            // setClustersData(prevData => [...prevData, duplicatedCluster]);
            // getAllClustersById()

            alertService.success(t('CLUSTER_DUPLICATED_SUCCESSFULLY'));
            setDuplicateModalVisible(false);
            setClusterToDuplicate(null);
        }
                 
            // Refresh the data to get the actual cluster from backend
            setTimeout(async () => {
                await getAllClustersById();
            }, 500);
            
        } catch (error) {
            alertService.error(error.message || t('FAILED_TO_DUPLICATE_CLUSTER'));
        } finally {
            setIsDuplicating(false);
        }
    };

    const canDeleteCluster = (cluster) => {
        // Check if cluster has no associated stores and no linked array
        const hasStores = cluster.stores && cluster.stores.length > 0;
        const hasLinkedArray = cluster.linkArrayName && cluster.linkArrayName !== null && cluster.linkArrayName !== 'None';
        
        return !hasStores && !hasLinkedArray;
    };

    const handleDeleteCluster = async () => {
        if (!clusterToDelete) return;

        setIsDeleting(true);
        try {
            const payload = {
                clusterId: clusterToDelete.clusterId
            };

            const response = await submitSets(
                submitCollection.archiveCluster,
                payload
            );

            if (!response?.status) {
                alertService.error(response?.extra || t('FAILED_TO_DELETE_CLUSTER'));
                return;
            }

            alertService.success(t('CLUSTER_DELETED_SUCCESSFULLY'));
            setDeleteModalVisible(false);
            setClusterToDelete(null);
            
            // Refresh the data
            await getAllClustersById();
            
        } catch (error) {
            alertService.error(error.message || t('FAILED_TO_DELETE_CLUSTER'));
        } finally {
            setIsDeleting(false);
        }
    };

    const validateArrayCompatibility = (targetArray, referenceArray) => {
        if (!targetArray || !referenceArray) {
            return { isCompatible: false, reason: 'Missing array data' };
        }
        
        // Get detailed array data from backendArraysData based on array IDs
        const targetDetails = backendArraysData.find(arr => arr.key == targetArray.value);
        const referenceDetails = backendArraysData.find(arr => arr.key == referenceArray);

        // console.log('targetDetails', targetDetails, 'ref', referenceDetails);
        
        
        if (!targetDetails || !referenceDetails) {
            return { isCompatible: false, reason: 'Leading array details not found' };
        }
        
        const targetFields = targetDetails.fieldsArrayHasFields || [];
        const referenceFields = referenceDetails.fieldsArrayHasFields || [];
        
        const issues = [];
        
        // Criteria 1: Number of fields must be identical
        if (targetFields.length !== referenceFields.length) {
            issues.push(`Different number of fields: ${targetFields.length} vs ${referenceFields.length} recommended`);
        }
        
        // Criteria 2: Max height must be identical 
        const targetMaxHeight = Math.max(...targetFields.map(field => {
            const height = field.height || 0;
            const uom = field.uom || 'cm';
            return measureConverter(uom, 'cm', height);
        }), 0);
        const referenceMaxHeight = Math.max(...referenceFields.map(field => {
            const height = field.height || 0;
            const uom = field.uom || 'cm';
            return measureConverter(uom, 'cm', height);
        }), 0);
        if (targetMaxHeight !== referenceMaxHeight) {
            issues.push(`Different max height: ${targetMaxHeight} vs ${referenceMaxHeight} recommended`);
        }
        
        // Criteria 3: Total array width must be equal or greater than reference
        const targetTotalWidth = targetFields.reduce((sum, field) => {
            const width = field.width || 0;
            const uom = field.uom || 'cm';
            return sum + measureConverter(uom, 'cm', width);
        }, 0);
        const referenceTotalWidth = referenceFields.reduce((sum, field) => {
            const width = field.width || 0;
            const uom = field.uom || 'cm';
            return sum + measureConverter(uom, 'cm', width);
        }, 0);
        if (targetTotalWidth < referenceTotalWidth) {
            issues.push(`Insufficient width: ${targetTotalWidth} is less than ${referenceTotalWidth} recommended`);
        }
        
        if (issues.length > 0) {
            return { 
                isCompatible: false, 
                reason: issues.join('\n')
            };
        }
        
        return { isCompatible: true, reason: null };
    };

    const validateMainTableArrayWidth = (targetArray, clusterRecord) => {
        if (!targetArray || !clusterRecord || !clusterRecord.stores || clusterRecord.stores.length === 0) {
            return { isCompatible: true, reason: null };
        }
        
        // Get detailed array data for the target
        const targetDetails = backendArraysData.find(arr => arr.key == targetArray.value);
        if (!targetDetails) {
            return { isCompatible: true, reason: null };
        }
        
        // Get widths of all linked arrays from the cluster's stores
        const storeArrayWidths = [];
        clusterRecord.stores.forEach(store => {
            if (store.fieldArray?.fieldArrayId && store.fieldArray.fieldArrayId !== 'None') {
                const storeArrayDetails = backendArraysData.find(arr => arr.key == store.fieldArray.fieldArrayId);
                if (storeArrayDetails) {
                    const storeArrayWidth = storeArrayDetails.fieldsArrayHasFields?.reduce((sum, field) => {
                        const width = field.width || 0;
                        const uom = field.uom || 'cm';
                        return sum + measureConverter(uom, 'cm', width);
                    }, 0) || 0;
                    storeArrayWidths.push(storeArrayWidth);
                }
            }
        });

        // If no store arrays found, no validation needed
        if (storeArrayWidths.length === 0) {
            return { isCompatible: true, reason: null };
        }

        // Find minimum width among store arrays
        const minStoreWidth = Math.min(...storeArrayWidths);

        // Calculate target array width
        const targetWidth = targetDetails.fieldsArrayHasFields?.reduce((sum, field) => {
            const width = field.width || 0;
            const uom = field.uom || 'cm';
            return sum + measureConverter(uom, 'cm', width);
        }, 0) || 0;

        // Check if target width exceeds minimum store width
        if (targetWidth > minStoreWidth) {
            return {
                isCompatible: false,
                reason: `Width ${targetWidth} exceeds assigned stores, least array width of ${minStoreWidth}`
            };
        }
        
        return { isCompatible: true, reason: null };
    };

    const getAllArrays = async () => {
        try {
            const response = await submitSets(
                submitCollection.getFieldArrayList,
                true
            );

            if (response?.status) {
                const filteredArrays = response.extra.filter(array => 
                    array.fieldsArrayHasFields && array.fieldsArrayHasFields.length > 0
                );
                
                const arrayOptions = filteredArrays.map(array => ({
                    value: array.id,
                    label: array.name
                }));
                
                setArraysData(arrayOptions);
                // console.log('arrData', arrayOptions);
                
            } else {
                alertService.error(response?.extra || t('FAILED_TO_FETCH_ARRAYS'));
            }
        } catch (error) {
            console.error('Error fetching arrays:', error);
            alertService.error(t('FAILED_TO_FETCH_ARRAYS'));
        }
    };

    const paginationItemRender = (page, type, originalElement) => {
        if (type === 'prev') {
            return <span style={{ display: 'inline-block' }}>{props.isRTL === 'rtl' ? '<' : '<'}</span>;
        }
        if (type === 'next') {
            return <span style={{ display: 'inline-block' }}>{props.isRTL === 'rtl' ? '>' : '>'}</span>;
        }
        return originalElement;
    };

    const fetchAllDepartmentStores = async () => {
        if (!selectedDepartmentId) {
            setAllDepartmentStores([]);
            return;
        }

        try {
            const payload = {
                storeName: null,
                storeCode: null,
                regionName: null,
                tagName: null,
                linkedArrayId: null,
                width: null,
                noOfFields: null,
                departmentId: selectedDepartmentId
            };

            const response = await submitSets(
                submitCollection.filterStores,
                payload
            );

            if (response?.status && response?.extra) {
                const transformedStores = response.extra.map(store => ({
                    key: `dept-store-${store.storeId}`,
                    storeId: store.storeId,
                    storeName: store.storeName,
                    storeCode: store.storeCode,
                    storeRegion: { regionName: store.regionName },
                    tagNames: store.tagNames || [],
                    linkedArray: store.linkedArrayName || '',
                    w: `W ${store.width}`,
                    f: `F ${store.noOfFields}`
                }));
                setAllDepartmentStores(transformedStores);
            } else {
                alertService.error(t('FAILED_TO_FETCH_STORES'));
                setAllDepartmentStores([]);
            }
        } catch (error) {
            alertService.error(t('FAILED_TO_FETCH_STORES'));
            setAllDepartmentStores([]);
        }
    };

        const fetchBackendArraysData = async (page = 1) => {
        if (!selectedDepartmentId) {
            setBackendArraysData([]);
            setTotalCount(0);
            return;
        }

        setArraysLoading(true);
        try {
            const response = await submitSets(
                submitCollection.fetchArrayData,
                {
                    departmentId: selectedDepartmentId,
                    startIndex: (page - 1) * pageSize,
                    maxResult: pageSize
                }
            );

            if (response?.status) {
                // Set total count from API response
                setTotalCount(response.count || 0);
                
                const transformedArrays = response.extra.map(array => ({
                    key: array.fireldArrayId,
                    arrayName: array.fieldArrayName,
                    code: `Code: #${array.fireldArrayId || 0}`,
                    linkArrayName: array.cluster ? array?.cluster.clusterName : null,
                    width: array.fields ? array.fields.reduce((sum, field) => sum + (field.width || 0), 0).toString() : '0',
                    fields: array.fields ? array.fields.length.toString() : '0',
                    s6: array.stores ? array.shelves : '0',
                    description: array.note || '',
                    fieldsArrayHasFields: array?.fields || [],
                    stores: (array.stores || []).map((store, storeIndex) => ({
                        ...store,
                        key: store.key || `${array.fireldArrayId}-store-${storeIndex}-${store.storeId || storeIndex}`,
                        storeId: store.storeId,
                        storeName: store.storeName,
                        storeCode: store.storeCode,
                        storeRegion: store.region || null,
                        tagNames: store.tagNames || [],
                        linkArrayName: array.fieldArrayName || (store.fieldArray ? store.fieldArray.fieldArrayName : 'None'),
                        tagNames: store.tagNames || [],
                        width: store.fieldArray?.fields
                            ? calculateTotalWidthInCm(store.fieldArray.fields).toString()
                            : '0',
                        fields: store.fieldArray?.fields 
                            ? store.fieldArray.fields.length.toString()
                            : '0'
                    }))
                }));
                setBackendArraysData(transformedArrays);
            } else {
                setBackendArraysData([]);
                setTotalCount(0);
            }
        } catch (error) {
            alertService.error(t('FAILED_TO_FETCH_BACKEND_ARRAYS'));
            setBackendArraysData([]);
            setTotalCount(0);
        } finally {
            setArraysLoading(false);
        }
    };

    const handlePageChange = (page) => {
        if (hasUnsavedChanges()) {
            setPendingAction(() => () => {
                setCurrentPage(page);
                fetchBackendArraysData(page);
            });
            setUnsavedChangesModalVisible(true);
        } else {
            setCurrentPage(page);
            fetchBackendArraysData(page);
        }
    };

    // Helper function to get unassigned stores
    const getUnassignedStores = () => {
        if (activeTab === 'arrays') {
            // Get all stores that are assigned to arrays
            const assignedStoreIds = new Set();
            backendArraysData.forEach(array => {
                if (array.stores) {
                    array.stores.forEach(store => {
                        assignedStoreIds.add(store.storeId);
                    });
                }
            });
            
            // Find unassigned stores from all department stores
            const unassignedStores = allDepartmentStores.filter(store => 
                !assignedStoreIds.has(store.storeId)
            ).map(store => ({
                ...store,
                key: `unassigned-array-${store.storeId}`,
                linkArrayName: null
            }));
            
            return unassignedStores;
        } else {
            // Get all stores that are assigned to clusters
            const assignedStoreIds = new Set();
            clustersData.forEach(cluster => {
                if (cluster.stores) {
                    cluster.stores.forEach(store => {
                        assignedStoreIds.add(store.storeId);
                    });
                }
            });
            
            // Find unassigned stores from all department stores
            const unassignedStores = allDepartmentStores.filter(store => 
                !assignedStoreIds.has(store.storeId)
            ).map(store => ({
                ...store,
                key: `unassigned-cluster-${store.storeId}`,
                linkArrayName: null
            }));
            
            return unassignedStores;
        }
    };

    const getCurrentDataSource = () => {
        let baseData;
        
        if (activeTab === 'arrays') {
            const currentArrayData = backendArraysData.length > 0 ? backendArraysData : [];
            
            if (!searchText.trim()) {
                baseData = currentArrayData;
            } else {
                baseData = currentArrayData.filter(array =>
                    array.stores && array.stores.some(store =>
                        store.storeName.toLowerCase().includes(searchText.toLowerCase())
                    )
                );
            }
            
            // Only add unassigned row on the last page when not searching
            if (!searchText.trim() && currentPage === Math.ceil(totalCount / pageSize)) {
                const unassignedStores = getUnassignedStores();
                if (unassignedStores.length > 0) {
                    const unassignedRow = {
                        key: 'unassigned-arrays',
                        arrayName: t('UNASSIGNED_TO_ARRAYS'),
                        code: '',
                        linkArrayName: null,
                        width: '0',
                        fields: '0',
                        s6: '0',
                        description: '',
                        fieldsArrayHasFields: [],
                        stores: unassignedStores
                    };
                    baseData = [...baseData, unassignedRow];
                }
            }

        } else {
            const currentData = clustersData.length > 0 ? clustersData : [];

            if (!searchText.trim()) {
                baseData = currentData;
            } else {
                baseData = currentData.filter(cluster =>
                    cluster.stores && cluster.stores.some(store =>
                        store.storeName.toLowerCase().includes(searchText.toLowerCase())
                    )
                );
            }
            
            // Only add unassigned row on the last page when not searching
                const unassignedStores = getUnassignedStores();
                if (unassignedStores.length > 0) {
                    const unassignedRow = {
                        key: 'unassigned-clusters',
                        clusterId: 'unassigned',
                        clusterName: t('UNASSIGNED_TO_CLUSTERS'), 
                        code: '',
                        linkArrayName: null,
                        width: '0',
                        fields: '0',
                        fieldArray: {},
                        fieldsArrayHasFields: [],
                        description: '',
                        stores: unassignedStores
                    };
                    baseData = [...baseData, unassignedRow];
                }

        }
        
        return baseData;
    };
    // Get total count of arrays (before pagination)
    const getTotalArrayCount = () => {
        if (activeTab !== 'arrays') return 0;

        const currentArrayData = backendArraysData.length > 0 ? backendArraysData : [];
        let baseData;

        if (!searchText.trim()) {
            baseData = currentArrayData;
        } else {
            baseData = currentArrayData.filter(array =>
                array.stores && array.stores.some(store =>
                    store.storeName.toLowerCase().includes(searchText.toLowerCase())
                )
            );
        }

        const unassignedStores = getUnassignedStores();
        if (unassignedStores.length > 0) {
            baseData = [...baseData, {}];
        }

        return baseData.length;
    };

    // Handle scroll for infinite loading
    const handleArrayTableScroll = (e) => {
        if (activeTab !== 'arrays' || isLoadingMoreArrays) return;

        const target = e.currentTarget;
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;
        const clientHeight = target.clientHeight;

        // Load more when scrolled 80% down
        if (scrollTop + clientHeight >= scrollHeight * 0.8) {
            const totalCount = getTotalArrayCount();
            const loadedCount = arrayCurrentPage * arrayPageSize;

            if (loadedCount < totalCount) {
                setIsLoadingMoreArrays(true);
                setTimeout(() => {
                    setArrayCurrentPage(prev => prev + 1);
                    setIsLoadingMoreArrays(false);
                }, 100);
            }
        }
    };

    const handleSave = async () => {
        const hasSelectedStores = Object.values(selectedStoreKeys).some(keys => keys.length > 0);
        const hasClusterArrayChanges = Object.keys(clusterArrayChanges).length > 0;
        const hasArrayClusterChanges = Object.keys(arrayClusterChanges).length > 0;
        const hasStoreArrayChanges = Object.keys(storeArrayChanges).length > 0;

        if (!hasSelectedStores && !hasClusterArrayChanges && !hasArrayClusterChanges && !hasStoreArrayChanges) {
            alertService.error(t('NO_CHANGES_TO_SAVE'));
            return;
        }

        setLoading(true);
        let successMessage = '';

        try {
            if (hasSelectedStores) {
                if (!selectedClusterForSave && !selectedArrayForSave) {
                    alertService.error(t('PLEASE_SELECT_CLUSTER_OR_ARRAY_TO_LINK_STORES'));
                    setLoading(false);
                    return;
                }

                const storeIds = Object.values(selectedStoreKeys).flat().map(key => {
                    const parts = key.split('-');
                    return parseInt(parts[parts.length - 1]);
                }).filter(id => !isNaN(id));

                const payload = {
                    storeIds: storeIds,
                    departmentID: selectedDepartmentId,
                    clusterId: selectedClusterForSave ? parseInt(selectedClusterForSave) : null,
                    fieldArrayID: selectedArrayForSave ? parseInt(selectedArrayForSave) : null
                };

                const response = await submitSets(
                    submitCollection.linkStoresToCluster,
                    payload
                );

                if (response?.status) {
                    if (activeTab === 'clusters') {
                        if (selectedArrayForSave) {
                            successMessage = showGlobalToast('success', t('STORE_CONNECTED_ARRAY'));
                        } else if (selectedClusterForSave) {
                            successMessage = showGlobalToast('success', t('STORE_CONNECTED_CLUSTERS'));
                        }
                    } else if (activeTab === 'arrays') {
                        if (selectedArrayForSave) {
                            successMessage = showGlobalToast('success', t('STORE_CONNECTED_ARRAY'));
                        } else if (selectedClusterForSave) {
                            successMessage = showGlobalToast('success', t('STORE_CONNECTED_CLUSTERS'));
                        }
                    }
                    setSelectedStoreKeys({});
                    setSelectedClusterForSave(null);
                    setSelectedArrayForSave(null);
                } else {
                    alertService.error(response?.extra || t('FAILED_TO_LINK_STORES'));
                    setLoading(false);
                    return;
                }
            }

            if (!hasSelectedStores && activeTab === 'clusters' && hasClusterArrayChanges) {
            //        const originalCluster = clustersData.find(cluster => cluster.clusterId === parseInt(clusterId));
            //              console.log('clusterid', originalCluster);
                         
            // const previousArrayId = originalCluster?.fieldArray?.fieldArrayId;
            
            // // Find the linkArrayName using the previous arrayId
            
            // const linkArrName = arrayData?.linkArrayName || null;
                

                const updatePromises = Object.entries(clusterArrayChanges).map(async ([clusterId, arrayId]) => {
                    const arrayData = backendArraysData.find(item => item.key === parseInt(arrayId));
            // console.log('arrayData', backendArraysData);
                    if (arrayId) {
                        const payload = {
                            clusterId: parseInt(clusterId),
                            fieldArrayId: parseInt(arrayId),
                            departmentId: selectedDepartmentId
                        };

                        return submitSets(
                            submitCollection.linkToFieldArrays,
                            payload
                        );
                    } else {

                      
                        const payload = {
                            clusterId: parseInt(clusterId),
                            departmentId: selectedDepartmentId,
                            // fieldArrayId: linkArrName
                        };

                        return submitSets(
                            submitCollection.unlinkFieldArrays,
                            payload
                        );
                    }
                });

                const responses = await Promise.all(updatePromises);
                const failedUpdates = responses.filter(response => !response?.status);

                if (failedUpdates.length === 0) {
                    successMessage = t('CLUSTER_ARRAY_LINKS_UPDATED_SUCCESSFULLY');
                    setClusterArrayChanges({});
                } else {
                    alertService.error(t('SOME_CLUSTER_UPDATES_FAILED'));
                    setLoading(false);
                    return;
                }
            }

            if (!hasSelectedStores && activeTab === 'arrays' && hasArrayClusterChanges) {
                const updatePromises = Object.entries(arrayClusterChanges).map(async ([storeKey, clusterId]) => {
                    // Extract store ID from the store key
                    const parts = storeKey.split('-');
                    const storeId = parseInt(parts[parts.length - 1]);

                    // Find the parent array for this store to get the fieldArrayID
                    const parentArray = backendArraysData.find(array =>
                        array.stores?.some(store => store.key === storeKey)
                    );
                    // console.log('backend', parentArray);
                    // const delClusterId = backendArraysData.
                    
                    const fieldArrayID = parentArray ? parentArray.key : null;

                    const storeInArray = parentArray?.stores?.find(store => store.key === storeKey);
                    const delClusterId = storeInArray?.cluster?.clusterId || null;

                    if(clusterId) {
                        const payload = {
                            clusterId: clusterId ? parseInt(clusterId) : null,
                            fieldArrayID: fieldArrayID,
                            departmentID: selectedDepartmentId,
                            storeIds: [storeId]
                        };

                        return submitSets(
                        submitCollection.linkStoresToCluster,
                        payload
                    );
                    } else {
                           const payload = {
                            clusterId: delClusterId ? parseInt(delClusterId) : null,
                            departmentId: selectedDepartmentId,
                            storeId: [storeId]
                        };

                        return submitSets(
                        submitCollection.unlinkStoreCluster,
                        payload
                    );
                    }    
                });

                const responses = await Promise.all(updatePromises);
                const failedUpdates = responses.filter(response => !response?.status);

                if (failedUpdates.length === 0) {
                    successMessage = t('STORE_CLUSTER_LINKS_UPDATED_SUCCESSFULLY');
                    setArrayClusterChanges({});
                } else {
                    alertService.error(responses.error?.message || t('SOMETHING_WENT_WRONG'));
                    setLoading(false);
                    return;
                }
            }

            if (!hasSelectedStores && activeTab === 'clusters' && hasStoreArrayChanges) {
                const updatePromises = Object.entries(storeArrayChanges).map(async ([storeKey, arrayId]) => {

                    // console.log('storekey', storeKey, 'arrayId', arrayId);
                    
                    // Extract store ID from the store key
                    const parts = storeKey.split('-');
                    const storeId = parseInt(parts[parts.length - 1]);

                    // Find the parent cluster for this store to get the clusterId
                    const parentCluster = clustersData.find(cluster =>
                        cluster.stores?.some(store => store.key === storeKey)
                    );
                    const clusterId = parentCluster ? parentCluster.clusterId : null;

                    if(arrayId) {
                        const payload = {
                            clusterId: null,
                            fieldArrayID: arrayId ? parseInt(arrayId) : null,
                            departmentID: selectedDepartmentId,
                            storeIds: [storeId]
                        };

                        return submitSets(
                        submitCollection.linkStoresToCluster,
                        payload
                    );
                    } else {
                           const payload = {
                            departmentId: selectedDepartmentId,
                            storeId: [storeId]
                        };

                        return submitSets(
                        submitCollection.unlinkCluster,
                        payload
                    );
                    }                                  
                });

                const responses = await Promise.all(updatePromises);
                const failedUpdates = responses.filter(response => !response?.status);

                if (failedUpdates.length === 0) {
                    successMessage = t('STORE_ARRAY_LINKS_UPDATED_SUCCESSFULLY');
                    setStoreArrayChanges({});
                } else {
                    alertService.error(t('SOME_STORE_UPDATES_FAILED'));
                    setLoading(false);
                    return;
                }
            }

            // await getAllClustersById();
            // // if (activeTab === 'arrays') {
            //     await fetchBackendArraysData();
            // }
               setTimeout(async () => {
                await getAllClustersById();
                await fetchBackendArraysData();
            }, 3000);

            // Show success message only after all operations complete successfully
            if (successMessage) {
                alertService.success(successMessage);
            }
        } catch (error) {
            console.error('Error saving changes:', error);
            alertService.error(t('FAILED_TO_SAVE_CHANGES'));
        } finally {
            setLoading(false);
        }
    };

    if (!selectedDepartmentId) {
        return (
            <div className='cluster-body'>
                <Col
                    xs={12} className={"main-content rg-mdview " + (props.isRTL === "rtl" ? "RTL" : "")} dir={props.isRTL}
                >
                    <Row>
                        <MDSidebarMenu />
                        <Col xs={12} lg={10}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '14px', color: props.dmode ? '#2CC990' : '#5128A0', fontFamily: 'Mulish, sans-serif', fontWeight: '700', marginTop: '2px', marginBottom: '10px', marginLeft: '10px' }}>
                                    <span>{t('CLUSTERS')}</span>
                                    <span>&gt;</span>
                                    <span>{t('DEPARTMENT')} :</span>
                            </div>
                            <div style={{display: 'flex', 
                                justifyContent: 'center',
                                alignItems: 'center', 
                                backgroundColor: props.dmode ? '#2f353e':'#FFF', 
                                borderRadius: '20px', 
                                // width: '100%', 
                                height: 'calc(100vh - 130px)', 
                                // ...props.isRTL === "rtl" ? { marginRight: '10px' } : { marginLeft: '10px' }
                            }}>
                                <div style={{ padding: '20px', textAlign: 'center' }}>
                                    <h1 style={{fontFamily: 'Mulish', fontWeight: 700, color: props.dmode ? '#2cc990':'#333333', opacity: 0.5, letterSpacing: '1px'}}>{i18n.t('CHOOSE_DEP_TO_START')}</h1>
                                    <ConfigProvider
                                        locale={heIL}
                                        direction={props.isRTL === "rtl" ? "rtl" : "ltr"}
                                    >
                                    <Select
                                        style={{ 
                                            width: 260, 
                                            marginLeft: '8px',
                                            marginRight: '10px', 
                                            fontFamily: 'Mulish, sans-serif', 
                                            fontWeight: '700', 
                                            color: props.dmode ? '#ccc' : '#5128A0', 
                                            textAlign: props.isRTL === "rtl" ? "right" : "left",
                                            backgroundColor: props.dmode ? '#2f353e' : 'white'
                                        }}
                                        size="small"
                                        ref={departmentSelectRef}
                                        options={allDepartments}
                                        placeholder={loading ? i18n.t('LOADING') : i18n.t('SELECT_DEPT')}
                                        value={selectedDepartmentId}
                                        loading={loading}
                                        autoFocus
                                        notFoundContent={t('NO_DATA')}
                                        showSearch
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                        onChange={(value) => {
                                            if (hasUnsavedChanges()) {
                                                setPendingAction(() => () => {
                                                    setSelectedDepartmentId(value);
                                                    setClustersData([]);
                                                    setSearchText('');
                                                    // Clear all multi-selection states when switching departments
                                                    setSelectedStoreKeys({});
                                                    setClusterArrayChanges({});
                                                    setArrayClusterChanges({});
                                                    setStoreArrayChanges({});
                                                    setSelectedClusterForSave(null);
                                                    setSelectedArrayForSave(null);
                                                    setSelectedClusterForArrayTab(null);
                                                    setSelectedArrayForArrayTab(null);
                                                    setExpandedRowKeys([]);
                                                });
                                                setUnsavedChangesModalVisible(true);
                                            } else {
                                                setSelectedDepartmentId(value);
                                                setClustersData([]);
                                                setSearchText('');
                                                // Clear all multi-selection states when switching departments
                                                setSelectedStoreKeys({});
                                                setClusterArrayChanges({});
                                                setArrayClusterChanges({});
                                                setStoreArrayChanges({});
                                                setSelectedClusterForSave(null);
                                                setSelectedArrayForSave(null);
                                                setSelectedClusterForArrayTab(null);
                                                setSelectedArrayForArrayTab(null);
                                                setExpandedRowKeys([]);
                                            }
                                        }}
                                    />
                                    </ConfigProvider>
                                    <style jsx>{`
                                        .ant-select .ant-select-selector::before {
                                            content: '';
                                            position: absolute;
                                            right: 24px;
                                            top: 0;
                                            bottom: 0;
                                            width: 0;
                                            border-left: 1px solid #828282;
                                            z-index: 1;
                                        }
                                        .ant-select .ant-select-selector {
                                            border: 1px solid #828282 !important;
                                        }
                                        .ant-select:hover .ant-select-selector {
                                            border: 1px solid #828282 !important;
                                        }
                                        .ant-select.ant-select-focused .ant-select-selector {
                                            border: 1px solid #828282 !important;
                                            box-shadow: 0 0 0 2px rgba(130, 130, 130, 0.1) !important;
                                        }
                                        .ant-select .ant-select-arrow {
                                            right: 7px !important;
                                            color: #828282 !important;
                                        }
                                        .ant-select .ant-select-arrow .anticon {
                                            color: #828282 !important;
                                        }
                                    `}</style>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </div>
        )
    }

    return (
        <div className="cluster-body">
            <Col
                xs={12} className={"main-content rg-mdview "+(props.isRTL==="rtl"?"RTL":"")} dir={props.isRTL}
            >
                <Row>
                    <MDSidebarMenu/>
                <Col xs={12} lg={10}>
                {/* Breadcrumb and Department Dropdown */}
                <div style={{ borderBottom: props.dmode ? '1px solid #2CC990' : '1px solid #f0f0f0', paddingBottom: '8px', marginLeft: '10px' }}>
                    <Breadcrumb 
                        className={props.dmode ? 'breadcrumb-dark' : 'breadcrumb-light'}
                        separator=">"
                        style={{
                            fontSize: '14px',
                            fontFamily: 'Mulish, sans-serif',
                            fontWeight: '700',
                            marginBottom: 0
                        }}
                    >
                        <Breadcrumb.Item>{t('CLUSTERS')}</Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span style={{ marginRight: '8px' }}>{t('DEPARTMENT')} :</span>
                            <ConfigProvider
                                locale={heIL}
                                direction={props.isRTL === "rtl" ? "rtl" : "ltr"}
                            >
                            <Select
                                ref={departmentSelectRef}
                                style={{ width: 200, fontFamily: 'Mulish, sans-serif', fontWeight: 700 }}
                                size="small"
                                options={allDepartments}
                                placeholder={t('SELECT_DEPARTMENT')}
                                value={selectedDepartmentId}
                                showSearch
                                autoFocus
                                className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                notFoundContent={t('NO_DATA')} 
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                    if (hasUnsavedChanges()) {
                                        setPendingAction(() => () => {
                                            setSelectedDepartmentId(value);
                                            setClustersData([]);
                                            setSearchText('');
                                            // Clear all multi-selection states when switching departments
                                            setSelectedStoreKeys({});
                                            setClusterArrayChanges({});
                                            setArrayClusterChanges({});
                                            setStoreArrayChanges({});
                                            setSelectedClusterForSave(null);
                                            setSelectedArrayForSave(null);
                                            setSelectedClusterForArrayTab(null);
                                            setSelectedArrayForArrayTab(null);
                                            setExpandedRowKeys([]);
                                        });
                                        setUnsavedChangesModalVisible(true);
                                    } else {
                                        setSelectedDepartmentId(value);
                                        setClustersData([]);
                                        setSearchText('');
                                        // Clear all multi-selection states when switching departments
                                        setSelectedStoreKeys({});
                                        setClusterArrayChanges({});
                                        setArrayClusterChanges({});
                                        setStoreArrayChanges({});
                                        setSelectedClusterForSave(null);
                                        setSelectedArrayForSave(null);
                                        setSelectedClusterForArrayTab(null);
                                        setSelectedArrayForArrayTab(null);
                                        setExpandedRowKeys([]);
                                    }
                                }}
                            />
                            </ConfigProvider>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>

                {/* Main Content */}
                <style>
                    {`
                    .breadcrumb-dark .ant-breadcrumb-link,
                    .breadcrumb-dark .ant-breadcrumb-separator {
                        color: #2CC990 !important;
                    }
                    .breadcrumb-light .ant-breadcrumb-link,
                    .breadcrumb-light .ant-breadcrumb-separator {
                        color: #5128A0 !important;
                    }
                    input[placeholder="Store Name"]::placeholder {
                        font-family: 'Noto Sans', sans-serif !important;
                        font-weight: 600 !important;
                        font-size: 12px !important;
                        color: #C4C4C4 !important;
                    }
                    .ant-select .ant-select-selection-placeholder {
                        color: #4F4F4F !important;
                        font-weight: 600 !important;
                        font-family: Mulish, sans-serif !important;
                        font-size: 12px !important;
                    }
                    .ant-select .ant-select-selection-item {
                        color: #333333 !important;
                        font-weight: 600 !important;
                        font-family: Mulish, sans-serif !important;
                        font-size: 12px !important;
                    }
                    .ant-table-expanded-row .ant-table-tbody > tr > td:first-child {
                        padding-left: 62px !important;
                    }
                    .ant-table-expanded-row .ant-table-selection-column {
                        padding-right: 4px !important;
                    }
                    .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
                        background-color: #FFF6E5 !important;
                    }
                    .hover-buttons-container {
                        position: absolute !important;
                        right: 8px !important;
                        transform: translateY(-50%) !important;
                        z-index: 10 !important;
                        margin-top: 5px !important;
                    }
                    .ant-table-cell {
                        position: relative !important;
                    }
                    .ant-table-expanded-row .ant-table-tbody > tr {
                        cursor: pointer !important;
                    }
                    .ant-table-expanded-row .ant-table-tbody > tr:hover {
                        background-color: #f5f5f5 !important;
                    }
                    .ant-table-expanded-row .ant-select {
                        cursor: default !important;
                    }
                    .ant-table-tbody > tr:not(.ant-table-expanded-row) {
                        cursor: pointer !important;
                    }
                    .ant-table-tbody > tr:not(.ant-table-expanded-row) .ant-select {
                        cursor: default !important;
                    }`}
                </style>
                <Card className="white-container-v3">

                    {/* Header */}
                    <div style={{ marginBottom: '18px' }}>
                        <Row align="middle" style={{ gap: '12px', flexWrap: 'nowrap' }}>
                            <Col style={{ paddingRight: 0 , paddingLeft: '25px', marginTop: '10px'}}>
                                   <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <div style={{ position: 'relative', display: 'flex', flexDirection: props.isRTL === 'rtl' ? 'row-reverse' : 'row' }}>
                                        {props.isRTL === 'rtl' && (
                                            <div style={{ height: '32px', borderRight: '1px solid #E0E0E0', margin: '0 0', display: 'flex', alignItems: 'center' }}>
                                                <Button
                                                    style={{
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0,
                                                        borderRight: 'none',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '32px',
                                                        width: '40px',
                                                        boxShadow: 'none',
                                                        background: props.dmode ? '#2f353e' : 'white',
                                                        border: '1px solid #828282'
                                                    }}
                                                    icon={<span style={{top: 0}}><Search size={16} color={props.dmode ? '#b1b1baff' : '#666'} /></span>}
                                                />
                                            </div>
                                        )}
                                        <Input
                                            placeholder={t('STORE_NAME')}
                                            allowClear
                                            style={{
                                                width: '300px',
                                                ...(props.isRTL === 'rtl' ? {
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                    borderLeft: 'none',
                                                    borderRight: '1px solid #828282',
                                                    borderTop: '1px solid #828282',
                                                    borderBottom: '1px solid #828282',
                                                    marginRight: '8px'
                                                } : {
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                    borderRight: '1px solid #828282',
                                                    borderLeft: '1px solid #828282',
                                                    borderTop: '1px solid #828282',
                                                    borderBottom: '1px solid #828282'
                                                }),
                                                background: props.dmode ? '#2f353e' : 'white',
                                                color: props.dmode ? '#ccc' : '#333'
                                            }}
                                            value={searchText}
                                            onChange={(e) => handleSearch(e.target.value)}
                                            onFocus={() => {setModalVisible(true);
                                                setPreventAutoOpen(false)
                                            }}
                                            // onBlur={() => setTimeout(() => setModalVisible(false), 200)}
                                            onBlur={() => {
                                                setPreventAutoOpen(true);
                                                setModalVisible(false)
                                            }}
                                        />
                                        {props.isRTL !== 'rtl' && (
                                            <div style={{ height: '32px', margin: '0 0', display: 'flex', alignItems: 'center' }}>
                                                <Button
                                                    style={{
                                                        borderTopLeftRadius: 0,
                                                        borderBottomLeftRadius: 0,
                                                        borderLeft: 'none',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '32px',
                                                        width: '40px',
                                                        boxShadow: 'none',
                                                        background: props.dmode ? '#2f353e' : 'white',
                                                        border: '1px solid #828282'
                                                    }}
                                                    icon={<span style={{top: 0}}><Search size={16} color={props.dmode ? '#b1b1baff' : '#666'} /></span>}
                                                />
                                            </div>
                                        )}
                                        <StoreSearchDropdown
                                            visible={modalVisible}
                                            setVisible={setModalVisible}
                                            preventAutoOpen={preventAutoOpen}
                                            setPreventAutoOpen={setPreventAutoOpen}
                                            // onClose={() => setModalVisible(!modalVisible)}
                                            onSelectStore={(store) => {
                                                setSearchText(store.storeName);
                                            }}
                                            searchText={searchText}
                                            onSearchChange={handleSearch}
                                            clusterList={allClusters}
                                            dmode={props.dmode}
                                            isRTL={props.isRTL}
                                            arrayList={arraysData}
                                            departmentId={selectedDepartmentId}
                                            onRefreshClusters={getAllClustersById}
                                            onRefreshArrays={fetchBackendArraysData}
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: props.isRTL === 'rtl' ? '0px' : '0px',
                                                width: '340px',
                                                zIndex: 9999
                                            }}
                                        />
                                    </div>
                                    <Button
                                        style={{
                                            ...(props.isRTL === 'rtl' ? { marginRight: '4px' } : { marginLeft: '4px' }),
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '32px',
                                            width: '40px',
                                            background: props.dmode ? '#2f353e' : 'white',
                                            border: '1px solid #828282'
                                        }}
                                        icon={<span style={{top: 2}}><Settings2 size={16} color={props.dmode ? '#b1b1baff' : '#666'} /></span>}
                                        onClick={() => {
                                            if (hasUnsavedChanges()) {
                                                setPendingAction(() => () => {
                                                    setStoreAdvancedFilterModalVisible(true);
                                                    setSelectedClusterForModal(null);
                                                    setSelectedArrayForModal(null);
                                                });
                                                setUnsavedChangesModalVisible(true);
                                            } else {
                                                setStoreAdvancedFilterModalVisible(true);
                                                setSelectedClusterForModal(null);
                                                setSelectedArrayForModal(null);
                                            }
                                        }}
                                        />
                                   </div>
                                
                            </Col>
                            <Col style={{ paddingLeft: 0, paddingTop: '10px' }}>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        if (hasUnsavedChanges()) {
                                            setPendingAction(() => () => {
                                                setNewClusterModalVisible(true);
                                            });
                                            setUnsavedChangesModalVisible(true);
                                        } else {
                                            setNewClusterModalVisible(true);
                                        }
                                    }}
                                    // disabled={!selectedDepartmentId}
                                    style={{
                                        backgroundColor:'#219653',
                                        borderColor: '#219653',
                                        borderRadius: '6px',
                                        fontFamily: 'Mulish, sans-serif',
                                        marginLeft: '0px'
                                    }}
                                >
                                    {t('NEW_CLUSTER')} +
                                </Button>
                            </Col>

                                {/* By Clusters and By Arrays Tabs */}
                            <Col style={{ flex: '1 1 auto', display: 'flex', justifyContent: 'flex-end', paddingRight: '25px', paddingTop: '10px' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        onClick={() => {setActiveTab('clusters'); setSelectedStoreKeys({}); setStoreArrayChanges({});}}
                                        style={{
                                            backgroundColor: activeTab === 'clusters' ? '#4A4A4A' : '#F5F5F5',
                                            color: activeTab === 'clusters' ? '#FFFFFF' : '#666666',
                                            border: activeTab === 'clusters' ? 'none' : '1px solid #E0E0E0',
                                            borderRadius: '6px',
                                            padding: '6px 16px',
                                            height: '32px',
                                            fontSize: '13px',
                                            fontFamily: 'Mulish, sans-serif',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {t('BY_CLUSTERS')}
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            if (hasUnsavedChanges()) {
                                                setPendingAction(() => () => {
                                                    setActiveTab('arrays');
                                                    setSelectedStoreKeys({});
                                                    setStoreArrayChanges({});
                                                });
                                                setUnsavedChangesModalVisible(true);
                                            } else {
                                                setActiveTab('arrays');
                                                setSelectedStoreKeys({});
                                                setStoreArrayChanges({});
                                            }
                                        }}
                                        style={{
                                            backgroundColor: activeTab === 'arrays' ? '#4A4A4A' : '#F5F5F5',
                                            color: activeTab === 'arrays' ? '#FFFFFF' : '#666666',
                                            border: activeTab === 'arrays' ? 'none' : '1px solid #E0E0E0',
                                            borderRadius: '6px',
                                            padding: '6px 16px',
                                            height: '32px',
                                            fontSize: '13px',
                                            fontFamily: 'Mulish, sans-serif',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {t('BY_ARRAYS')}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div
                        ref={arrayTableRef}
                        // onScroll={handleArrayTableScroll}
                        style={{ maxHeight: 'calc(100vh - 150px)', overflow: 'auto', margin: '0 14px 6px 14px' }}
                    >
                        {activeTab === 'clusters' ? (
                            <Table
                                className={`top-aligned-table ${props.dmode ? 'table-dark' : ''}`}
                                columns={columns}
                                dataSource={getCurrentDataSource()}
                                showHeader={false}
                                pagination={false}
                                rowHoverable
                                loading={clustersLoading}
                                // virtual
                                locale={{
                                    emptyText: <CustomEmptyData
                                        message={selectedDepartmentId ?
                                            t('NO_CLUSTERS_FOUND') :
                                            t('SELECT_DEPT_TO_VIEW_CLUSTERS')}
                                    />
                                }}
                                rowClassName={(record) => expandedRowKeys.includes(record.key) ? 'expanded-parent-row' : ''}
                                onRow={(record) => {
                                    return {
                                        onClick: (event) => {
                                            // Prevent expansion if clicking on Select component, buttons, dropdown items, or ThumbnailSvg
                                            if (event.target.closest('.ant-select') ||
                                                event.target.closest('.ant-btn') ||
                                                event.target.closest('.ant-select-dropdown') ||
                                                event.target.closest('.ant-select-item-option') ||
                                                event.target.closest('svg') ||
                                                event.target.classList.contains('ant-select-item-option')) {
                                                return;
                                            }

                                            const isExpanded = expandedRowKeys.includes(record.key);
                                            let newExpandedKeys;

                                            if (isExpanded) {
                                                newExpandedKeys = expandedRowKeys.filter(k => k !== record.key);
                                            } else {
                                                newExpandedKeys = [...expandedRowKeys, record.key];
                                            }

                                            if (hasUnsavedChanges()) {
                                                setPendingAction(() => () => {
                                                    setExpandedRowKeys(newExpandedKeys);
                                                });
                                                setUnsavedChangesModalVisible(true);
                                            } else {
                                                setExpandedRowKeys(newExpandedKeys);
                                            }
                                        }
                                    };
                                }}
                                expandable={{
                                    expandedRowKeys: expandedRowKeys,
                                    onExpand: (expanded, record) => {
                                        if (hasUnsavedChanges()) {
                                            setPendingAction(() => () => {
                                                if (expanded) {
                                                    setExpandedRowKeys([...expandedRowKeys, record.key]);
                                                } else {
                                                    setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.key));
                                                }
                                            });
                                            setUnsavedChangesModalVisible(true);
                                        } else {
                                            if (expanded) {
                                                setExpandedRowKeys([...expandedRowKeys, record.key]);
                                            } else {
                                                setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.key));
                                            }
                                        }
                                    },
                                    expandedRowRender: (parentRecord) => (
                                        <div style={{ margin: 0, padding: '0', backgroundColor: '#FAFAFA' }}>
                                            {parentRecord.stores && parentRecord.stores.length > 0 ? (
                                                <Table
                                                    className={props.dmode ? 'table-dark' : ''}
                                                    columns={storeColumns}
                                                    dataSource={parentRecord.stores}
                                                    pagination={false}
                                                    showHeader={false}
                                                    size="small"
                                                    style={{ marginBottom: 0 }}
                                                    rowSelection={{
                                                        type: 'checkbox',
                                                        selectedRowKeys: selectedStoreKeys[parentRecord.key] || [],
                                                        onChange: (selectedRowKeys, selectedRows) => {
                                                            setSelectedStoreKeys(prev => ({
                                                                ...prev,
                                                                [parentRecord.key]: selectedRowKeys
                                                            }));
                                                        },
                                                    }}
                                                    onRow={(storeRecord) => {
                                                        return {
                                                            onClick: (event) => {
                                                                // Prevent selection if clicking on Select component, dropdown items, or ThumbnailSvg
                                                                if (event.target.closest('.ant-select') ||
                                                                    event.target.closest('.ant-select-dropdown') ||
                                                                    event.target.closest('.ant-select-item-option') ||
                                                                    event.target.closest('svg') ||
                                                                    event.target.classList.contains('ant-select-item-option')) {
                                                                    return;
                                                                }
                                                                
                                                                const storeKey = storeRecord.key;
                                                                const currentSelectedKeys = selectedStoreKeys[parentRecord.key] || [];
                                                                const isSelected = currentSelectedKeys.includes(storeKey);
                                                                let newSelectedKeys;
                                                                
                                                                if (isSelected) {
                                                                    newSelectedKeys = currentSelectedKeys.filter(k => k !== storeKey);
                                                                } else {
                                                                    newSelectedKeys = [...currentSelectedKeys, storeKey];
                                                                }
                                                                
                                                                setSelectedStoreKeys(prev => ({
                                                                    ...prev,
                                                                    [parentRecord.key]: newSelectedKeys
                                                                }));
                                                            }
                                                        };
                                                    }}
                                                />
                                            ) : (
                                                <div style={{ padding: '12px', color: '#666', fontSize: '13px', textAlign: 'center' }}>
                                                    {t('NO_STORES_AVAILABLE_CLUSTER')}
                                                </div>
                                            )}
                                        </div>
                                    ),
                                    rowExpandable: () => true,
                                    expandIcon: ({ expanded, onExpand, record }) => (
                                        expanded ?
                                            <span
                                                style={{ cursor: 'pointer', marginRight: 0, userSelect: 'none' }}
                                                onClick={e => { e.preventDefault(); e.stopPropagation(); onExpand(record, e); }}
                                            >
                                                <UpOutlined style={{ fontSize: 16, color: '#666' }} />
                                            </span>
                                            :
                                            <span
                                                style={{ cursor: 'pointer', marginRight: 0, userSelect: 'none' }}
                                                onClick={e => { e.preventDefault(); e.stopPropagation(); onExpand(record, e); }}
                                            >
                                                <UpOutlined rotate={180} style={{ fontSize: 16, color: '#666' }} />
                                            </span>
                                    ),
                                }}
                                style={{ minWidth: '100%', borderTop: getCurrentDataSource() && getCurrentDataSource().length > 0 ? '1px solid #BDBDBD' : 'none'}}
                            />
                        ) : (
                            <Table
                                className={`top-aligned-table ${props.dmode ? 'table-dark' : ''}`}
                                columns={arrayColumns}
                                loading={arraysLoading || isLoadingMoreArrays}
                                dataSource={getCurrentDataSource()}
                                showHeader={false}
                                pagination={false}
                                rowHoverable
                                locale={{
                                    emptyText: <CustomEmptyData
                                        message={t('NO_ARRAYS_FOUND')}
                                    />
                                }}
                                rowClassName={(record) => expandedRowKeys.includes(record.key) ? 'expanded-parent-row' : ''}
                                onRow={(record) => {
                                    return {
                                        onClick: (event) => {
                                            // Prevent expansion if clicking on Select component, buttons, dropdown items, or ThumbnailSvg
                                            if (event.target.closest('.ant-select') ||
                                                event.target.closest('.ant-btn') ||
                                                event.target.closest('.ant-select-dropdown') ||
                                                event.target.closest('.ant-select-item-option') ||
                                                event.target.closest('svg') ||
                                                event.target.classList.contains('ant-select-item-option')) {
                                                return;
                                            }

                                            const isExpanded = expandedRowKeys.includes(record.key);
                                            let newExpandedKeys;

                                            if (isExpanded) {
                                                newExpandedKeys = expandedRowKeys.filter(k => k !== record.key);
                                            } else {
                                                newExpandedKeys = [...expandedRowKeys, record.key];
                                            }

                                            if (hasUnsavedChanges()) {
                                                setPendingAction(() => () => {
                                                    setExpandedRowKeys(newExpandedKeys);
                                                });
                                                setUnsavedChangesModalVisible(true);
                                            } else {
                                                setExpandedRowKeys(newExpandedKeys);
                                            }
                                        }
                                    };
                                }}
                                expandable={{
                                    expandedRowKeys: expandedRowKeys,
                                    onExpand: (expanded, record) => {
                                        if (hasUnsavedChanges()) {
                                            setPendingAction(() => () => {
                                                if (expanded) {
                                                    setExpandedRowKeys([...expandedRowKeys, record.key]);
                                                } else {
                                                    setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.key));
                                                }
                                            });
                                            setUnsavedChangesModalVisible(true);
                                        } else {
                                            if (expanded) {
                                                setExpandedRowKeys([...expandedRowKeys, record.key]);
                                            } else {
                                                setExpandedRowKeys(expandedRowKeys.filter(key => key !== record.key));
                                            }
                                        }
                                    },
                                    expandedRowRender: (parentRecord) => (
                                        <div style={{ margin: 0, padding: '0', backgroundColor: '#FAFAFA' }}>
                                            {parentRecord.stores && parentRecord.stores.length > 0 ? (
                                                <Table
                                                    className={props.dmode ? 'table-dark' : ''}
                                                    columns={storeColumns}
                                                    dataSource={parentRecord.stores}
                                                    pagination={false}
                                                    showHeader={false}
                                                    size="small"
                                                    style={{ marginBottom: 0 }}
                                                    rowSelection={{
                                                        type: 'checkbox',
                                                        selectedRowKeys: selectedStoreKeys[parentRecord.key] || [],
                                                        onChange: (selectedRowKeys, selectedRows) => {
                                                            setSelectedStoreKeys(prev => ({
                                                                ...prev,
                                                                [parentRecord.key]: selectedRowKeys
                                                            }));
                                                        },
                                                    }}
                                                    onRow={(storeRecord) => {
                                                        return {
                                                            onClick: (event) => {
                                                                // Prevent selection if clicking on Select component, dropdown items, or ThumbnailSvg
                                                                if (event.target.closest('.ant-select') ||
                                                                    event.target.closest('.ant-select-dropdown') ||
                                                                    event.target.closest('.ant-select-item-option') ||
                                                                    event.target.closest('svg') ||
                                                                    event.target.classList.contains('ant-select-item-option')) {
                                                                    return;
                                                                }
                                                                
                                                                const storeKey = storeRecord.key;
                                                                const currentSelectedKeys = selectedStoreKeys[parentRecord.key] || [];
                                                                const isSelected = currentSelectedKeys.includes(storeKey);
                                                                let newSelectedKeys;
                                                                
                                                                if (isSelected) {
                                                                    newSelectedKeys = currentSelectedKeys.filter(k => k !== storeKey);
                                                                } else {
                                                                    newSelectedKeys = [...currentSelectedKeys, storeKey];
                                                                }
                                                                
                                                                setSelectedStoreKeys(prev => ({
                                                                    ...prev,
                                                                    [parentRecord.key]: newSelectedKeys
                                                                }));
                                                            }
                                                        };
                                                    }}
                                                />
                                            ) : (
                                                <div style={{ padding: '12px', color: '#666', fontSize: '13px', textAlign: 'center' }}>
                                                    {t('NO_STORES_AVAILABLE_ARRAY')}
                                                </div>
                                            )}
                                        </div>
                                    ),
                                    rowExpandable: () => true,
                                    expandIcon: ({ expanded, onExpand, record }) => (
                                        expanded ?
                                            <span
                                                style={{ cursor: 'pointer', marginRight: 0, userSelect: 'none' }}
                                                onClick={e => { e.preventDefault(); e.stopPropagation(); onExpand(record, e); }}
                                            >
                                                <UpOutlined style={{ fontSize: 16, color: '#666' }} />
                                            </span>
                                            :
                                            <span
                                                style={{ cursor: 'pointer', marginRight: 0, userSelect: 'none' }}
                                                onClick={e => { e.preventDefault(); e.stopPropagation(); onExpand(record, e); }}
                                            >
                                                <UpOutlined rotate={180} style={{ fontSize: 16, color: '#666' }} />
                                            </span>
                                    ),
                                }}
                                style={{ minWidth: '100%', borderTop: getCurrentDataSource() && getCurrentDataSource().length > 0 ? '1px solid #BDBDBD' : 'none' }}
                            />
                        )}
                        <style jsx>{`
                            .ant-table-thead > tr > th {
                                border-top: 1px solid #BDBDBD !important;
                                border-bottom: 1px solid #BDBDBD !important;
                            }
                            .ant-table-tbody > tr > td {
                                border-bottom: 1px solid #5128A0 !important;
                            }
                            .ant-table-tbody > tr:hover > td {
                                background-color: #FFF6E5 !important;
                                border-bottom: 1px solid #5128A0 !important;
                            }
                            .ant-empty {
                                border: none !important;
                                background: transparent !important;
                            }
                            .ant-empty:hover {
                                background: transparent !important;
                            }
                            .ant-table-placeholder {
                                border: none !important;
                                background: transparent !important;
                            }
                            .ant-table-placeholder:hover {
                                background: transparent !important;
                            }
                            .ant-table-placeholder .ant-table-cell {
                                border-bottom: none !important;
                                background: transparent !important;
                            }
                            .ant-table-placeholder .ant-table-cell:hover {
                                background: transparent !important;
                                border-bottom: none !important;
                            }
                            .ant-table-tbody .ant-table-placeholder > td {
                                border-bottom: none !important;
                                background: transparent !important;
                            }
                            .ant-table-tbody .ant-table-placeholder > td:hover {
                                background: transparent !important;
                                border-bottom: none !important;
                            }
                            .ant-table-expanded-row .ant-table-tbody > tr > td {
                                border-bottom: 1px solid #BDBDBD !important;
                            }
                            .ant-table-expanded-row .ant-table-tbody > tr:last-child > td {
                                border-bottom: none !important;
                            }
                            .ant-table-tbody > tr:not(.ant-table-expanded-row):hover > td .ant-tag {
                                background-color: #FFEAC3 !important;
                            }
                            .ant-table-expanded-row .ant-table-tbody > tr.ant-table-row-selected > td {
                                background-color: transparent !important;
                            }
                            .ant-table-expanded-row .ant-table-tbody > tr.ant-table-row-selected:hover > td {
                                background-color: #FFF6E5 !important;
                            }
                            .ant-table-tbody > tr.ant-table-expanded-row > td {
                                background-color: #FAFAFA !important;
                            }
                            .ant-table-tbody > tr.ant-table-expanded-row:hover > td {
                                background-color: #FAFAFA !important;
                            }
                            .ant-table-expanded-row .ant-table-tbody > tr > td {
                                background-color: #FAFAFA !important;
                            }
                            .ant-table-expanded-row .ant-table-tbody > tr:hover > td {
                                background-color: #FFF6E5 !important;
                            }
                            .ant-checkbox-checked .ant-checkbox-inner {
                                background-color: #34C759 !important;
                                border-color: #34C759 !important;
                            }
                            .ant-checkbox-checked::after {
                                border-color: #34C759 !important;
                            }
                            .ant-checkbox:hover .ant-checkbox-inner {
                                border-color: #34C759 !important;
                            }
                            .ant-checkbox-input:focus + .ant-checkbox-inner {
                                border-color: #34C759 !important;
                            }
                            #tooltip-purple.tooltip .tooltip-inner {
                                background-color: #5128A0 !important;
                                color: white !important;
                                opacity: 1 !important;
                            }
                            #tooltip-purple.tooltip {
                                opacity: 1 !important;
                            }
                            #tooltip-purple.tooltip .tooltip-arrow::before {
                                border-top-color: #5128A0 !important;
                            }
                            .custom-warning-tooltip .tooltip-inner,
                            .custom-warning-tooltip.tooltip .tooltip-inner,
                            .tooltip.custom-warning-tooltip .tooltip-inner,
                            .bs-tooltip-auto[class*="custom-warning-tooltip"] .tooltip-inner,
                            .bs-tooltip-end[class*="custom-warning-tooltip"] .tooltip-inner,
                            .bs-tooltip-start[class*="custom-warning-tooltip"] .tooltip-inner,
                            .bs-tooltip-top[class*="custom-warning-tooltip"] .tooltip-inner,
                            .bs-tooltip-bottom[class*="custom-warning-tooltip"] .tooltip-inner {
                                background-color: #f5f5f5 !important;
                                color: #333 !important;
                                opacity: 1 !important;
                                padding: 0 !important;
                            }
                            .custom-warning-tooltip,
                            .custom-warning-tooltip.tooltip,
                            .tooltip.custom-warning-tooltip {
                                opacity: 1 !important;
                            }
                            .custom-warning-tooltip .tooltip-arrow::before,
                            .custom-warning-tooltip.tooltip .tooltip-arrow::before,
                            .tooltip.custom-warning-tooltip .tooltip-arrow::before,
                            .bs-tooltip-end[class*="custom-warning-tooltip"] .tooltip-arrow::before {
                                border-right-color: #f5f5f5 !important;
                            }
                            .bs-tooltip-start[class*="custom-warning-tooltip"] .tooltip-arrow::before {
                                border-left-color: #f5f5f5 !important;
                            }
                            .bs-tooltip-top[class*="custom-warning-tooltip"] .tooltip-arrow::before {
                                border-top-color: #f5f5f5 !important;
                            }
                            .bs-tooltip-bottom[class*="custom-warning-tooltip"] .tooltip-arrow::before {
                                border-bottom-color: #f5f5f5 !important;
                            }
                            .ant-select .ant-select-selector::before {
                                content: '';
                                position: absolute;
                                right: 24px;
                                top: 0;
                                bottom: 0;
                                width: 0;
                                border-left: 1px solid #828282;
                                z-index: 1;
                            }
                            .ant-select .ant-select-selector {
                                border: 1px solid #828282 !important;
                            }
                            .ant-select:hover .ant-select-selector {
                                border: 1px solid #828282 !important;
                            }
                            .ant-select.ant-select-focused .ant-select-selector {
                                border: 1px solid #828282 !important;
                                box-shadow: 0 0 0 2px rgba(130, 130, 130, 0.1) !important;
                            }
                            .ant-select .ant-select-arrow {
                                right: 7px !important;
                                color: #828282 !important;
                            }
                            .ant-select .ant-select-arrow .anticon {
                                color: #828282 !important;
                            }
                            .ant-table-expanded-row > td {
                                padding: 0 !important;
                            }
                            .ant-table-expanded-row > td > .ant-table-wrapper {
                                padding: 0 !important;
                            }
                            .department-select .ant-select-selector .ant-select-selection-item {
                                font-weight: 700 !important;
                                color: #5128A0 !important;
                            }
                            .department-select-dark .ant-select-selector .ant-select-selection-item {
                                font-weight: 700 !important;
                                color: #2CC990 !important;
                            }
                            .department-select .ant-select-selector {
                                background-color: transparent !important;
                            }
                            .department-select-dark .ant-select-selector {
                                background-color: #2f353e !important;
                            }
                            .card {
                                --bs-card-border-color: transparent !important;
                            }
                            .table-dark .ant-table-container {
                                background-color: #2f353e !important;
                            }
                            .table-dark .ant-table-tbody > tr > td {
                                background-color: #2f353e !important;
                                color: white !important;
                                border-bottom: 1px solid #2CC990 !important;
                            }
                            .table-dark .ant-table-tbody > tr:hover > td {
                                background-color: #3a4149 !important;
                                border-bottom: 1px solid #2CC990 !important;
                            }
                            .table-dark .ant-table-expanded-row .ant-table-tbody > tr > td {
                                background-color: #2f353e !important;
                                color: white !important;
                                border-bottom: 1px solid #2CC990 !important;
                            }
                            .table-dark .ant-table-expanded-row .ant-table-tbody > tr:hover > td {
                                background-color: #3a4149 !important;
                                border-bottom: 1px solid #2CC990 !important;
                            }
                            .table-dark .ant-table-expanded-row .ant-table-tbody > tr:last-child > td {
                                border-bottom: none !important;
                            }
                            .table-dark .ant-select .ant-select-selector {
                                background-color: #2f353e !important;
                                border-color: #2CC990 !important;
                                color: #ccc !important;
                            }
                            .table-dark .ant-select .ant-select-selection-item {
                                color: #ccc !important;
                            }
                            .table-dark .ant-select .ant-select-selection-placeholder {
                                color: #999 !important;
                            }
                            .table-dark .ant-select .ant-select-arrow {
                                color: #2CC990 !important;
                            }
                            .table-dark .ant-select:hover .ant-select-selector {
                                border-color: #2CC990 !important;
                            }
                            .table-dark .ant-select.ant-select-focused .ant-select-selector {
                                border-color: #2CC990 !important;
                                box-shadow: 0 0 0 2px rgba(44, 201, 144, 0.2) !important;
                            }
                            .white-container-footer .ant-select .ant-select-selector {
                                background-color: ${props.dmode ? '#2f353e' : 'white'} !important;
                                border-color: ${props.dmode ? '#2CC990' : '#999'} !important;
                                color: ${props.dmode ? '#ccc' : '#000'} !important;
                            }
                            .white-container-footer .ant-select .ant-select-selection-item {
                                color: ${props.dmode ? '#ccc' : '#000'} !important;
                            }
                            .white-container-footer .ant-select .ant-select-selection-placeholder {
                                color: ${props.dmode ? '#999' : '#999'} !important;
                            }
                            .white-container-footer .ant-select .ant-select-arrow {
                                color: ${props.dmode ? '#2CC990' : '#00000040'} !important;
                            }
                            .white-container-footer .ant-select:hover .ant-select-selector {
                                border-color: ${props.dmode ? '#2CC990' : '#40a9ff'} !important;
                            }
                            .white-container-footer .ant-select.ant-select-focused .ant-select-selector {
                                border-color: ${props.dmode ? '#2CC990' : '#40a9ff'} !important;
                                box-shadow: 0 0 0 2px ${props.dmode ? 'rgba(44, 201, 144, 0.2)' : 'rgba(24, 144, 255, 0.2)'} !important;
                            }
                        `}</style>
                    </div>
                   
                   {(getCurrentDataSource() && getCurrentDataSource().length > 0) && (
                   <div className="white-container-footer" style={{ borderTop: '1px solid #4F4F4F', marginLeft: '14px', marginRight: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <Button
                            onClick={() => {
                                const selectedDepartment = allDepartments.find(dept => dept.value === selectedDepartmentId);
                                exportToExcel(getCurrentDataSource(), activeTab, {
                                    selectedDepartment: selectedDepartment?.label
                                },
                                props.signedobj
                                );
                            }}
                            disabled={hasOnlyUnassignedRecords()}
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                        >
                        {t('EXPORT')} {!loading && <UploadFileIcon size={20} />}
                        </Button>
                        <ConfigProvider
                            locale={heIL}
                            direction={props.isRTL === "rtl" ? "rtl" : "ltr"}
                        >
                         {activeTab === 'clusters' ? (
                            Object.values(selectedStoreKeys).some(keys => keys.length > 0) ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        
                                <span style={{ fontSize: '13px', color: props.dmode ? '#ccc' : '#666', fontFamily: 'Mulish, sans-serif', fontWeight: '700' }}>
                                    {t('MULTI_SELECTION')}:
                                </span>
                                <Select
                                    placeholder={t('LINK_TO_ARRAY')}
                                    size="small"
                                    style={{ width: 120, fontSize: '13px' }}
                                    value={selectedArrayForSave}
                                    onChange={(value) => setSelectedArrayForSave(value === 'None' ? null : value)}
                                    showSearch
                                    optionFilterProp="labelText"
                                    filterOption={(input, option) => {
                                        const searchText = option.labelText || '';
                                        return searchText.toLowerCase().includes(input.toLowerCase());
                                    }}
                                    className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                    options={[
                                        { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                        ...arraysData.map(array => ({
                                            ...array,
                                            labelText: array.label || ''
                                        }))
                                    ]}
                                />
                                <Select
                                    placeholder={t('LINK_TO_CLUSTER')}
                                    size="small"
                                    style={{ width: 130, fontSize: '13px'}}
                                    value={selectedClusterForSave}
                                    onChange={(value) => setSelectedClusterForSave(value === 'None' ? null : value)}
                                    showSearch
                                    optionFilterProp="labelText"
                                    filterOption={(input, option) => {
                                        const searchText = option.labelText || '';
                                        return searchText.toLowerCase().includes(input.toLowerCase());
                                    }}
                                    className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                    options={[
                                        { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                        ...allClusters.map(cluster => ({
                                            ...cluster,
                                            labelText: cluster.label || cluster.name || ''
                                        }))
                                    ]}
                                />
                           
                            </div>
                            ) : null
                                    ) : (Object.values(selectedStoreKeys).some(keys => keys.length > 0) ? (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                            <span style={{ fontSize: '13px', color: '#000', fontFamily: 'Mulish, sans-serif', fontWeight: '700' }}>
                                                {t('MULTI_SELECTION')}:
                                            </span>
                                            <Select
                                                placeholder={t('LINK_TO_ARRAY')}
                                                size="small"
                                                style={{ width: 120, fontSize: '13px' }}
                                                value={selectedArrayForSave}
                                                onChange={(value) => setSelectedArrayForSave(value === 'None' ? null : value)}
                                                showSearch
                                                optionFilterProp="labelText"
                                                filterOption={(input, option) => {
                                                    const searchText = option.labelText || '';
                                                    return searchText.toLowerCase().includes(input.toLowerCase());
                                                }}
                                                className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                                options={[
                                                    { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                                    ...arraysData.map(array => ({
                                                        ...array,
                                                        labelText: array.label || ''
                                                    }))
                                                ]}                                            
                                            />
                                            <Select
                                                placeholder={t('LINK_TO_CLUSTER')}
                                                size="small"
                                                style={{ width: 130, fontSize: '13px' }}
                                                value={selectedClusterForSave}
                                                onChange={(value) => setSelectedClusterForSave(value === 'None' ? null : value)}
                                                showSearch
                                                optionFilterProp="labelText"
                                                filterOption={(input, option) => {
                                                    const searchText = option.labelText || '';
                                                    return searchText.toLowerCase().includes(input.toLowerCase());
                                                }}
                                                className={props.isRTL === "rtl" ? "rtl-select-input" : ""}
                                                options={[
                                                    { value: 'None', label: t('NONE'), labelText: t('NONE') },
                                                    ...allClusters.map(cluster => ({
                                                        ...cluster,
                                                        labelText: cluster.label || cluster.name || ''
                                                    }))
                                                ]}
                                            />
                                        </div>
                                        ) : null
                                    )
                            }
                                 </ConfigProvider>
                                {activeTab === 'arrays' && totalCount > pageSize && (
                                    <Pagination
                                        current={currentPage}
                                        pageSize={pageSize}
                                        total={totalCount}
                                        onChange={handlePageChange}
                                        showSizeChanger={false}
                                        showTotal={(total, range) => 
                                            props.isRTL === 'rtl' 
                                                ? `${total} ${t('OF')} ${range[1]}-${range[0]}`
                                                : `${range[0]}-${range[1]} ${t('OF')} ${total}`
                                        }
                                        size="small"
                                        style={{ marginLeft: 'auto' }}
                                        itemRender={paginationItemRender}
                                    />
                            )}
                    </div>
                    <Button
                        type="primary"
                        onClick={handleSave}
                        loading={loading}
                        disabled={!hasUnsavedChanges() || isAssigningToSameCluster() || isAssigningToSameArray() || isAssigningStoreToSameArrayViaDropdown() || isAssigningStoreToSameClusterViaDropdown()}
                        style={{
                        backgroundColor: '#219653',
                        borderColor: '#219653',
                        borderRadius: '6px',
                        fontFamily: 'Mulish, sans-serif',
                        fontWeight: '600'
                        }}
                    >
                        {t('SAVE')} {!loading && <CheckCircleOutlined style={{ fontSize: '16px' }} />}
                    </Button>
                    </div>
                )}

                </Card>
                {/* New Cluster Modal */}
               <NewClusterModal
                    visible={newClusterModalVisible}
                    onClose={() => {
                        setNewClusterModalVisible(false);
                        setIsEditMode(false);
                        setEditClusterData(null);
                    }}
                    onCreateCluster={handleCreateCluster}
                    onUpdateCluster={handleUpdateCluster}
                    loading={loading}
                    isRTL={props.isRTL === 'rtl'}
                    isEdit={isEditMode}
                    dmode={props.dmode}
                    editData={editClusterData}
                />
                <StoreAdvancedFilterModal
                    show={storeAdvancedFilterModalVisible}
                    onClose={() => setStoreAdvancedFilterModalVisible(false)}
                    clusterList = {allClusters}
                    arrayList = {arraysData}
                    activeTopTab= {activeTab}
                    preSelectedCluster={selectedClusterForModal}
                    preSelectedArray={selectedArrayForModal}
                    isRTL={props.isRTL === 'rtl'}
                    showModal = {setStoreAdvancedFilterModalVisible}
                    setSelectedPlusInArray = {selecedPlusInArray}
                    dmode={props.dmode}
                    departmentId={selectedDepartmentId}
                    onRefreshClusters={getAllClustersById}
                    onRefreshArrays={fetchBackendArraysData}
                    onShowToast={showGlobalToast}
                />
                <DuplicateClusterModal
                    visible={duplicateModalVisible}
                    onClose={() => {
                        setDuplicateModalVisible(false);
                        setClusterToDuplicate(null);
                    }}
                    onConfirm={handleDuplicateCluster}
                    loading={isDuplicating}
                    clusterData={clusterToDuplicate}
                    dmode={props.dmode}
                    isRTL={props.isRTL === 'rtl'}
                />
                <DeleteClusterModal
                    visible={deleteModalVisible}
                    onClose={() => {
                        setDeleteModalVisible(false);
                        setClusterToDelete(null);
                    }}
                    onConfirm={handleDeleteCluster}
                    loading={isDeleting}
                    clusterData={clusterToDelete}
                    dmode={props.dmode}
                    isRTL={props.isRTL === 'rtl'}
                />
                <DeleteWarningModal
                    visible={warningModalVisible}
                    onClose={() => {
                        setWarningModalVisible(false);
                        setWarningClusterData(null);
                    }}
                    clusterData={warningClusterData}
                    dmode={props.dmode}
                    isRTL={props.isRTL === 'rtl'}
                />
                <UnsavedChangesModal
                    visible={unsavedChangesModalVisible}
                    onClose={() => {
                        setUnsavedChangesModalVisible(false);
                        setPendingAction(null);
                    }}
                    onCancel={handleCancelFromModal}
                    onSave={handleSaveFromModal}
                    onDiscard={handleDiscardFromModal}
                    loading={loading}
                    dmode={props.dmode}
                    isRTL={props.isRTL === 'rtl'}
                />
                </Col>
                </Row>
            </Col>

            {/* Global Toast - persists after modal closes */}
            {globalToast && (
                <div style={{
                    position: 'fixed',
                    top: '18%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 10001,
                    padding: '12px 16px',
                    borderRadius: '6px',
                    backgroundColor: globalToast.type === 'success' ? '#4CAF50' : globalToast.type === 'warning' ? '#FF9800' : '#EB5757',
                    color: 'white',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
                    fontSize: '14px',
                    fontWeight: '600',
                    // minWidth: '300px',
                    textAlign: 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                        <span>{globalToast.message}</span>
                        <span
                            onClick={() => setGlobalToast(null)}
                            style={{
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                padding: '2px',
                                transition: 'opacity 0.2s',
                                opacity: 1,
                                marginLeft: '12px',
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M12 4L4 12M4 4L12 12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </span>
                    </div>
                </div>
            )}
        </div>

    )
}

export default clusters